// Set flag to indicate testlabFilters is active (prevents conflicts with other filter systems)
window.testlabFiltersActive = true;

// Wait for jQuery to be available
function waitForJQuery() {
  if (typeof jQuery !== 'undefined') {
    // Remove any existing initialization
    jQuery(document).off('testlabFilters:init');
    jQuery(document).one('testlabFilters:init', initializeTestlabFilters);
    jQuery(document).trigger('testlabFilters:init');
  } else {
    setTimeout(waitForJQuery, 100);
  }
}

// Start waiting for jQuery
waitForJQuery();

// Price formatting utility functions
function formatPriceInput(value) {
  console.log('[filter-debug] formatPriceInput called with:', value, typeof value);
  
  // If value is empty, return empty string
  if (!value || value.trim() === '') {
    return '';
  }
  
  // Remove any non-numeric characters (including commas) to get clean number
  let cleanValue = value.replace(/[^\d]/g, '');
  console.log('[filter-debug] Cleaned value:', cleanValue);
  
  // If no digits found, return empty string
  if (cleanValue === '') {
    return '';
  }
  
  // Convert to number and round to whole dollars
  const numValue = Math.round(parseInt(cleanValue) || 0);
  console.log('[filter-debug] Parsed number:', numValue);
  
  // Add commas for thousands
  const formatted = numValue.toLocaleString();
  console.log('[filter-debug] Formatted result:', formatted);
  return formatted;
}

function parsePriceInput(formattedValue) {
  // Remove commas and return clean number
  return formattedValue.replace(/,/g, '');
}

/** Escape text placed inside HTML elements (e.g. chip labels). */
function escapeHtmlText(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

/** Escape values placed inside double-quoted HTML attributes. */
function escapeHtmlAttr(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function initializeTestlabFilters() {
  const $forms = jQuery('form.faceted-filter-form');
  const $mobileFilterToggle = jQuery('[data-mobile-filter-toggle]');
  const $mobileFilterOverlay = jQuery('[data-mobile-filter-overlay]');
  const $mobileFilterSidebar = jQuery('[data-mobile-filter-sidebar]');
  const $mobileFilterClose = jQuery('[data-mobile-filter-close]');
  const $sidebarSection = jQuery('.sidebar-section');
  const $collectionGrid = jQuery('.collection-matrix');
  const $loadingIcon = jQuery('.paginate');


  console.log('[filter-debug] Initializing testlab filters:', {
    formsFound: $forms.length,
    mobileToggleFound: $mobileFilterToggle.length,
    mobileOverlayFound: $mobileFilterOverlay.length,
    mobileSidebarFound: $mobileFilterSidebar.length,
    mobileCloseFound: $mobileFilterClose.length
  });

  // Handle multiple forms - find desktop and mobile forms
  const $desktopForm = $forms.filter(function () {
    return jQuery(this).closest('.sidebar-section').length > 0;
  });
  const $mobileForm = $forms.filter(function () {
    return jQuery(this).closest('[data-mobile-filter-sidebar]').length > 0;
  });

  console.log('[filter-debug] Form analysis:', {
    desktopFormFound: $desktopForm.length,
    mobileFormFound: $mobileForm.length
  });

  // Use the desktop form as primary (or mobile if desktop not found) - will be updated after cloning
  let $form = $desktopForm.length ? $desktopForm : $mobileForm;

  // Add global event listener to track collection:updated events
  window.addEventListener('collection:updated', function (event) {
    // Collection updated event received
  });

  // Add global lazySizes monitoring to track any other calls
  if (typeof lazySizes !== 'undefined') {
    const originalCheckElems = lazySizes.loader.checkElems;
    lazySizes.loader.checkElems = function() {
      console.log('[filter-debug] lazySizes.loader.checkElems() called from:', new Error().stack);
      return originalCheckElems.apply(this, arguments);
    };
  }

  if (!$form.length) {
    return;
  }

  // Remove conflicting event handlers from theme's built-in scripts
  // This prevents double-click issues caused by multiple scripts handling the same events

  // Remove z__jsCollection.js handlers
  jQuery('#sort-by').off('change');
  jQuery('#tag_filter').off('change');
  jQuery('body').off('click', '[data-option-filter]');
  jQuery('body').off('click', '[data-clear-filter]');
  jQuery('body').off('click', '[data-reset-filters]');

  // Remove z__jsSidebar.js form change handler that causes page reloads
  // Handle both desktop and mobile forms
  const desktopFormElement = $desktopForm.length ? $desktopForm[0] : null;
  const mobileFormElement = $mobileForm.length ? $mobileForm[0] : null;

  // Declare variables outside the if blocks
  let newDesktopForm = null;
  let newMobileForm = null;

  if (desktopFormElement) {
    // Clone desktop form to remove event listeners
    newDesktopForm = desktopFormElement.cloneNode(true);
    desktopFormElement.parentNode.replaceChild(
      newDesktopForm,
      desktopFormElement
    );
    console.log('[filter-debug] Desktop form cloned');
  }

  if (mobileFormElement) {
    // Clone mobile form to remove event listeners
    newMobileForm = mobileFormElement.cloneNode(true);
    mobileFormElement.parentNode.replaceChild(newMobileForm, mobileFormElement);
    console.log('[filter-debug] Mobile form cloned');
  }

  // Update form references to point to the new cloned forms
  const $newDesktopForm = newDesktopForm
    ? jQuery(newDesktopForm)
    : $desktopForm;
  const $newMobileForm = newMobileForm ? jQuery(newMobileForm) : $mobileForm;
  $form = $newDesktopForm.length ? $newDesktopForm : $newMobileForm;

  // Initialize review rating checkboxes from URL parameters
  function initializeReviewRatingFilters(urlToUse) {
    console.log('[filter-debug] Initializing review rating filters from URL parameters');
    
    // Get URL parameters from provided URL or window.location.search
    const searchParams = urlToUse 
      ? new URL(urlToUse, window.location.origin).search 
      : window.location.search;
    const urlParams = new URLSearchParams(searchParams);
    const reviewRatingValues = urlParams.getAll('filter.c.review_rating');
    
    console.log('[filter-debug] Review rating values from URL:', reviewRatingValues, 'Source:', urlToUse || 'window.location');
    
    // Set checked state for review rating checkboxes in both forms
    if (reviewRatingValues.length > 0) {
      $newDesktopForm
        .add($newMobileForm)
        .find('input[name="filter.c.review_rating"]')
        .each(function() {
          const ratingValue = this.value;
          const shouldBeChecked = reviewRatingValues.includes(ratingValue);
          this.checked = shouldBeChecked;
          
          if (shouldBeChecked) {
            console.log('[filter-debug] Set review rating checkbox as checked:', {
              id: this.id,
              value: ratingValue
            });
          }
        });
      
      // Return true if any review rating filters were set
      return true;
    }
    
    return false;
  }

  // Helper to read currently selected review rating values (integers)
  function getSelectedReviewRatings() {
    const selectedRatings = [];

    $newDesktopForm
      .add($newMobileForm)
      .find('input[name="filter.c.review_rating"]:checked')
      .each(function () {
        const ratingValue = parseInt(this.value, 10);
        if (!Number.isNaN(ratingValue) && !selectedRatings.includes(ratingValue)) {
          selectedRatings.push(ratingValue);
        }
      });

    return selectedRatings;
  }

  // Show or hide the client-side empty state for review rating filters
  function toggleReviewRatingEmptyState(showState) {
    const $collectionMain = jQuery('.collection__main');
    if (!$collectionMain.length) {
      return;
    }

    let $emptyState = $collectionMain.find('.review-rating-filter-empty-state');

    if (!showState) {
      if ($emptyState.length) {
        $emptyState.hide();
      }
      return;
    }

    if (!$emptyState.length) {
      $emptyState = jQuery(
        '<div class="collection__no-products review-rating-filter-empty-state"><p>No products match the selected review ratings.</p></div>'
      );
      $collectionMain.append($emptyState);
    }

    $emptyState.show();
  }

  function createEmptyReviewRatingCountMap() {
    return { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
  }

  function updateReviewRatingFilterOptions(ratingCounts) {
    const counts = ratingCounts || createEmptyReviewRatingCountMap();

    function updateFormReviewOptions($formInstance) {
      if (!$formInstance || !$formInstance.length) {
        return;
      }

      const $ratingInputs = $formInstance.find('input[name="filter.c.review_rating"]');
      if (!$ratingInputs.length) {
        return;
      }

      $ratingInputs.each(function () {
        const $checkbox = jQuery(this);
        const starValue = parseInt($checkbox.val(), 10);
        if (Number.isNaN(starValue)) {
          return;
        }

        const count = counts[starValue] || 0;
        const $listItem = $checkbox.closest('.faceted-filter-group-display__list-item');
        const $countEl = $listItem.find('.review-rating-count');
        if ($countEl.length) {
          $countEl.text(`(${count})`);
        }

        const isChecked = $checkbox.is(':checked');
        const shouldDisable = count === 0 && !isChecked;
        $checkbox.prop('disabled', shouldDisable);
        $listItem.toggleClass('faceted-filter-group-display__list-item--disabled', shouldDisable);

        const $label = $listItem.find('.faceted-filter-group-display__list-item-label');
        if (shouldDisable) {
          $label.css('cursor', 'not-allowed');
        } else {
          $label.css('cursor', '');
        }
      });
    }

    updateFormReviewOptions($newDesktopForm);
    updateFormReviewOptions($newMobileForm);

    const $legacyLists = jQuery('.sidebar-block__review-ratings-list');
    if ($legacyLists.length) {
      $legacyLists.each(function () {
        jQuery(this)
          .find('[data-review-rating-option]')
          .each(function () {
            const $item = jQuery(this);
            const starValue = parseInt($item.attr('data-review-rating-option'), 10);
            if (Number.isNaN(starValue)) {
              return;
            }
            const count = counts[starValue] || 0;
            const $countEl = $item.find('.review-rating-count');
            if ($countEl.length) {
              $countEl.text(`(${count})`);
            }
            $item.toggleClass('review-rating-option--disabled', count === 0);
          });
      });
    }
  }

  // Filter the collection grid on the client based on selected review rating checkboxes
  function applyReviewRatingFilterToCollectionGrid() {
    const selectedRatings = getSelectedReviewRatings();
    const $collectionGrid = jQuery('.collection-matrix');

    console.log('[filter-debug] applyReviewRatingFilterToCollectionGrid: selectedRatings =', selectedRatings);

    if (!$collectionGrid.length) {
      console.log('[filter-debug] No collection grid found');
      toggleReviewRatingEmptyState(false);
      updateReviewRatingFilterOptions(createEmptyReviewRatingCountMap());
      return;
    }

    const $products = $collectionGrid.find('[data-review-rating]');
    console.log('[filter-debug] Found products with data-review-rating:', $products.length);

    if (!$products.length) {
      console.log('[filter-debug] No products with data-review-rating attribute');
      toggleReviewRatingEmptyState(false);
      updateReviewRatingFilterOptions(createEmptyReviewRatingCountMap());
      return;
    }

    const ratingCounts = createEmptyReviewRatingCountMap();
    let visibleCount = 0;
    let hiddenCount = 0;

    $products.each(function () {
      const $product = jQuery(this);
      const ratingAttr = parseFloat($product.attr('data-review-rating'));
      const hasRating = !Number.isNaN(ratingAttr);
      const roundedRating = hasRating ? Math.floor(ratingAttr) : null;
      const matches =
        selectedRatings.length === 0 ||
        (hasRating && selectedRatings.includes(roundedRating));

      // Log zero-rated products when filters are active
      if (selectedRatings.length > 0 && ratingAttr === 0) {
        console.log('[filter-debug] Zero-rated product found:', {
          rating: ratingAttr,
          hasRating: hasRating,
          roundedRating: roundedRating,
          matches: matches,
          willBeHidden: !matches
        });
      }

      if (matches) {
        $product.removeClass('review-rating-filter-hidden').css('display', '');
        visibleCount += 1;
        if (hasRating && roundedRating >= 1 && roundedRating <= 5) {
          ratingCounts[roundedRating] += 1;
        }
      } else {
        $product.addClass('review-rating-filter-hidden').css('display', 'none');
        hiddenCount += 1;
      }
    });

    console.log('[filter-debug] Filter complete:', {
      totalProducts: $products.length,
      visible: visibleCount,
      hidden: hiddenCount,
      selectedRatings: selectedRatings
    });

    toggleReviewRatingEmptyState(visibleCount === 0);
    updateReviewRatingFilterOptions(ratingCounts);

    // Reposition promo cards after filtering
    repositionPromoCardsAfterFiltering($collectionGrid, visibleCount);
  }

  // Reposition promo cards after review rating filtering
  function repositionPromoCardsAfterFiltering($collectionGrid, visibleProductCount) {
    // Get all direct children of the collection grid in their current DOM order
    const $allChildren = $collectionGrid.children();
    
    if (!$allChildren.length) {
      return;
    }

    // Build array of all items with their properties
    const items = [];
    $allChildren.each(function(index) {
      const $item = jQuery(this);
      const isPromoCard = $item.hasClass('promo-card');
      const isProduct = $item.attr('data-review-rating') !== undefined;
      const isHidden = $item.hasClass('review-rating-filter-hidden') || 
                       ($item.css('display') === 'none' && isProduct);
      
      // Read data-card-index for promo cards
      const cardIndex = isPromoCard ? parseInt($item.attr('data-card-index'), 10) : null;
      
      items.push({
        element: this,
        $element: $item,
        originalIndex: index,
        isPromoCard: isPromoCard,
        isProduct: isProduct,
        isHidden: isHidden,
        cardIndex: cardIndex // Store card index for promo cards
      });
    });

    // Get visible products and promo cards
    const visibleProducts = items.filter(i => i.isProduct && !i.isHidden);
    let promoCards = items.filter(i => i.isPromoCard);

    // Detect if we're on desktop or mobile
    const isDesktop = window.innerWidth > 1100;
    
    // Filter promo cards based on viewport
    // Desktop: skip cards with is-hidden-desktop-only class (mobile-only cards)
    // Mobile: skip cards with is-hidden-mobile-only class (desktop-only cards)
    promoCards = promoCards.filter(promoCard => {
      const $card = promoCard.$element;
      const isHiddenDesktopOnly = $card.hasClass('is-hidden-desktop-only');
      const isHiddenMobileOnly = $card.hasClass('is-hidden-mobile-only');
      
      if (isDesktop) {
        // On desktop, skip mobile-only cards
        if (isHiddenDesktopOnly) {
          return false;
        }
      } else {
        // On mobile, skip desktop-only cards
        if (isHiddenMobileOnly) {
          return false;
        }
      }
      return true;
    });

    if (promoCards.length === 0) {
      return;
    }

    // Sort promo cards by data-card-index to ensure correct order
    promoCards.sort((a, b) => {
      const aIndex = a.cardIndex !== null ? a.cardIndex : Infinity;
      const bIndex = b.cardIndex !== null ? b.cardIndex : Infinity;
      if (aIndex !== bIndex) {
        return aIndex - bIndex;
      }
      // If cardIndex is the same or missing, fall back to originalIndex
      return a.originalIndex - b.originalIndex;
    });

    // Determine products per row from CSS classes
    let productsPerRow = 3; // default
    const firstItem = items.find(i => !i.isHidden);
    if (firstItem) {
      const $first = firstItem.$element;
      if ($first.hasClass('one-third')) {
        productsPerRow = 3;
      } else if ($first.hasClass('one-half')) {
        productsPerRow = 2;
      } else if ($first.hasClass('one-fourth')) {
        productsPerRow = 4;
      }
    }

    // Calculate new positions for promo cards
    // Strategy: Use cardIndex directly - it IS the correct position (1-indexed)
    // Convert to 0-indexed for targetPosition: targetPosition = cardIndex - 1
    const promoCardPositions = [];
    
    // Sort visible products by their originalIndex to maintain order
    visibleProducts.sort((a, b) => a.originalIndex - b.originalIndex);
    
    promoCards.forEach(promoCard => {
      const cardIndex = promoCard.cardIndex;
      
      // If cardIndex is null or invalid, skip this promo card
      if (cardIndex === null || isNaN(cardIndex)) {
        return;
      }
      
      // cardIndex IS the correct position (1-indexed), convert to 0-indexed
      const targetPosition = cardIndex - 1;
      
      promoCardPositions.push({
        promoCard: promoCard,
        targetPosition: targetPosition,
        cardIndex: cardIndex // Store cardIndex for sorting
      });
    });

    // Sort by cardIndex ONLY - cardIndex IS the correct position
    promoCardPositions.sort((a, b) => {
      const aCardIndex = a.cardIndex !== null ? a.cardIndex : Infinity;
      const bCardIndex = b.cardIndex !== null ? b.cardIndex : Infinity;
      return aCardIndex - bCardIndex;
    });

    // Build new order: merge products and promo cards by their target positions
    // Strategy: cardIndex (1-indexed) = position in final array
    // Products fill sequential positions, promo cards go at their cardIndex positions
    // Only show promo cards if there are enough items to reach their position
    
    const reorderedItems = [];
    let productIndex = 0;
    let promoIndex = 0;
    let currentPosition = 0;
    
    // Continue until we've placed all products
    while (productIndex < visibleProducts.length) {
      // Check if there are promo cards that should be inserted at the current position
      // Insert ALL promo cards that match currentPosition (they're already sorted by cardIndex)
      let insertedPromo = false;
      while (promoIndex < promoCardPositions.length) {
        const nextPromo = promoCardPositions[promoIndex];
        
        if (nextPromo.targetPosition === currentPosition) {
          // Insert this promo card
          reorderedItems.push(nextPromo.promoCard);
          nextPromo.promoCard.$element.show(); // Ensure it's visible
          promoIndex++;
          currentPosition++;
          insertedPromo = true;
        } else if (nextPromo.targetPosition < currentPosition) {
          // This promo card's position has passed - shouldn't happen, but handle it
          nextPromo.promoCard.$element.hide();
          promoIndex++;
        } else {
          // This promo card is in the future, break and add products
          break;
        }
      }
      
      // If we inserted promo cards, continue to check for more at the next position
      if (insertedPromo) {
        continue;
      }
      
      // Add next product
      reorderedItems.push(visibleProducts[productIndex]);
      productIndex++;
      currentPosition++;
    }
    
    // After placing all products, hide any remaining promo cards that can't be positioned yet
    // (Their target positions are beyond the number of items we have)
    while (promoIndex < promoCardPositions.length) {
      const nextPromo = promoCardPositions[promoIndex];
      // Hide promo cards whose target position is beyond what we can fill
      nextPromo.promoCard.$element.hide();
      promoIndex++;
    }

    // Reorder DOM elements by detaching and re-appending in correct order
    // This is more reliable than moving elements one by one
    reorderedItems.forEach(item => {
      jQuery(item.element).detach();
    });
    
    reorderedItems.forEach(item => {
      $collectionGrid.append(item.element);
    });
  }
  
  // Call initialization after forms are ready
  initializeReviewRatingFilters();
  
  // Apply rating filter with a delay to ensure DOM is fully loaded
  setTimeout(() => {
    console.log('[filter-debug] Applying initial rating filter after DOM ready');
    applyReviewRatingFilterToCollectionGrid();
  }, 100);

  // Hook into infinite scroll to re-apply rating filter after new products load
  if (typeof window.PXUTheme !== 'undefined' && window.PXUTheme.infiniteScroll) {
    const originalLoadNextPage = window.PXUTheme.infiniteScroll.loadNextPage;
    
    window.PXUTheme.infiniteScroll.loadNextPage = function(url, $button) {
      console.log('[filter-debug] Infinite scroll loading next page:', url);
      
      // Call the original method
      const result = originalLoadNextPage.call(this, url, $button);
      
      // Re-apply rating filter after products are appended to DOM
      setTimeout(() => {
        console.log('[filter-debug] Re-applying rating filter after infinite scroll');
        applyReviewRatingFilterToCollectionGrid();
      }, 500);
      
      return result;
    };
    
    console.log('[filter-debug] Infinite scroll hook installed for rating filter');
  }

  // Remove any existing testlabFilters handlers to prevent duplicates
  jQuery(document).off('testlabFilters:init');
  $form.find('input[type="checkbox"]').off('change click input');
  $form.find('.faceted-filter-group-display__list-item-label').off('click');
  $form.off('submit');
  $mobileFilterToggle.off('click');
  $mobileFilterClose.off('click');
  $mobileFilterOverlay.off('click');

  // Also remove any existing handlers from the form itself
  $form.off('change', 'input[type="checkbox"]');
  $form.off('click', 'input[type="checkbox"]');
  $form.off('click', '.faceted-filter-group-display__list-item-label');

  // Review rating checkboxes now use simple integer values (1-5) with filter.c.review_rating parameter
  // No special grouping logic needed - they work like regular checkboxes

  // Add additional form submission prevention with logging
  $form.on('submit', function (e) {
    console.log('[filter-debug] Form submit event caught (SAFETY NET):', {
      timestamp: new Date().toISOString(),
      defaultPrevented: e.defaultPrevented,
      isPropagationStopped: e.isPropagationStopped
        ? e.isPropagationStopped()
        : false,
      target: e.target.tagName,
      currentTarget: e.currentTarget.tagName,
      submitter: e.submitter ? e.submitter.tagName : 'none',
      submitterId: e.submitter ? e.submitter.id : 'none'
    });
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    console.log('[filter-debug] Form submission prevented by safety net');
    return false;
  });

  // Add global form submission prevention as a last resort
  jQuery(document).on('submit', 'form.faceted-filter-form', function (e) {
    console.log('[filter-debug] GLOBAL Form submit event caught:', {
      timestamp: new Date().toISOString(),
      defaultPrevented: e.defaultPrevented,
      isPropagationStopped: e.isPropagationStopped
        ? e.isPropagationStopped()
        : false,
      target: e.target.tagName,
      currentTarget: e.currentTarget.tagName,
      submitter: e.submitter ? e.submitter.tagName : 'none',
      submitterId: e.submitter ? e.submitter.id : 'none'
    });
    
    // Allow price filter submit buttons to work by checking if the submitter is a price filter button
    const submitter = e.submitter;
    if (submitter && submitter.closest('.faceted-filter-group-display__submit')) {
      console.log('[filter-debug] GLOBAL Form submission - allowing price filter submit button');
      // Don't prevent default - let the price filter handler work
      return;
    }
    
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    console.log('[filter-debug] GLOBAL Form submission prevented');
    return false;
  });

  // Add global click tracking for remove filter buttons (but don't prevent - let our AJAX handlers work)
  jQuery(document).on(
    'click',
    '.faceted-active-filters__remove-filter, .faceted-active-filters__clear',
    function (e) {
      console.log('--> [filter-debug] GLOBAL Remove/Clear filter button clicked:', {
        timestamp: new Date().toISOString(),
        href: jQuery(this).attr('href'),
        textContent: this.textContent.trim(),
        className: this.className,
        defaultPrevented: e.defaultPrevented,
        isPropagationStopped: e.isPropagationStopped
          ? e.isPropagationStopped()
          : false
      });
      // Don't prevent here - let our specific AJAX handlers work
    }
  );

  // Add global event delegation for mobile filter buttons
  jQuery(document).on('click', '[data-clear-filters]', function (e) {
    console.log('--> [filter-debug] GLOBAL Clear filters button clicked');
    e.preventDefault();
    e.stopPropagation();

    // Uncheck all checkboxes in both forms
    $newDesktopForm
      .add($newMobileForm)
      .find('input[type="checkbox"]')
      .prop('checked', false);

    // Clear price range inputs
    $newDesktopForm
      .add($newMobileForm)
      .find('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]')
      .val('');
    console.log('[filter-debug] Global clear - all price inputs cleared');

    console.log(
      '[filter-debug] All filters cleared via global clear button handler'
    );

    // Update UI
    updateActiveFiltersDisplay();
    updateActiveFilterCounts();
    // Intentionally do not collapse filter accordions — same UX as clearing the last chip.
  });

  jQuery(document).on('click', '[data-apply-filters]', function (e) {
    console.log('--> [filter-debug] GLOBAL Apply filters button clicked');
    e.preventDefault();
    e.stopPropagation();

    // Add visual feedback
    const $button = jQuery(this);
    $button.addClass('is-loading').prop('disabled', true);

    // Close the mobile sidebar and trigger AJAX update
    closeMobileSidebar();

    // Remove loading state after a short delay
    setTimeout(() => {
      $button.removeClass('is-loading').prop('disabled', false);
    }, 1000);
  });

  // Remove all beforeunload listeners during filter updates
  let beforeunloadListeners = [];
  let beforeunloadEventListeners = [];

  function disableBeforeunload() {
    // Set flag to prevent beforeunload alerts
    window.testlabFiltersBeforeunloadDisabled = true;
    console.log(
      '[filter-debug] Disabled beforeunload alerts during filter update'
    );
  }

  function enableBeforeunload() {
    // Re-enable beforeunload alerts
    window.testlabFiltersBeforeunloadDisabled = false;
    console.log(
      '[filter-debug] Re-enabled beforeunload alerts after filter update'
    );
  }

  // Add a flag to prevent theme scripts from re-initializing
  window.testlabFiltersActive = true;

  /*
   * iPhone/iOS Safari CSS Recommendations:
   * Add these styles to your CSS file to properly handle iPhone modal positioning:
   *
   * .mobile-filter-sidebar.ios-safari {
   *   height: calc(var(--vh, 1vh) * 100);
   *   max-height: calc(var(--vh, 1vh) * 100);
   * }
   *
   * .mobile-filter-sidebar.ios-safari.ios-absolute-position {
   *   position: absolute !important;
   *   top: 0;
   *   left: 0;
   *   right: 0;
   *   bottom: 0;
   * }
   *
   * .mobile-filter-sidebar.has-safe-area {
   *   padding-bottom: env(safe-area-inset-bottom);
   *   padding-top: env(safe-area-inset-top);
   * }
   *
   * .mobile-filter-sidebar .mobile-filter-buttons {
   *   padding-bottom: max(16px, env(safe-area-inset-bottom));
   *   position: sticky;
   *   bottom: 0;
   *   background: white;
   *   border-top: 1px solid #e0e0e0;
   *   z-index: 10;
   * }
   *
   * body.ios-modal-open {
   *   overflow: hidden !important;
   *   height: 100% !important;
   * }
   */

  // Handle product sidebar detection (from z__jsSidebar.js)
  if (jQuery('[data-product-sidebar]').length) {
    jQuery('.section--has-sidebar-option').addClass('has-sidebar-enabled');
    jQuery('.section--has-sidebar-option').removeClass('has-sidebar-disabled');
  } else {
    jQuery('.section--has-sidebar-option').removeClass('has-sidebar-enabled');
    jQuery('.section--has-sidebar-option').addClass('has-sidebar-disabled');
  }

  // Debug: Check what other event handlers might be attached
  console.log('[filter-debug] Checking for other event handlers on form:', {
    formElement: $form[0],
    hasSubmitHandler: $._data($form[0], 'events')
      ? $._data($form[0], 'events').submit
      : 'none',
    hasChangeHandler: $._data($form[0], 'events')
      ? $._data($form[0], 'events').change
      : 'none'
  });

  // Debug: Check for any elements that might cause navigation
  const potentialNavigationElements = $form.find(
    'a[href], button[type="submit"], input[type="submit"]'
  );
  console.log('[filter-debug] Potential navigation elements found in form:', {
    count: potentialNavigationElements.length,
    elements: potentialNavigationElements.map(function () {
      return {
        tag: this.tagName,
        type: this.type,
        href: this.href,
        id: this.id,
        className: this.className,
        textContent: this.textContent
          ? this.textContent.trim().substring(0, 50)
          : ''
      };
    })
  });

  // Also check for any form elements that might have action attributes
  const formsWithAction = $form.find('form[action]');
  console.log('[filter-debug] Forms with action attributes:', {
    count: formsWithAction.length,
    forms: formsWithAction.map(function () {
      return {
        action: this.action,
        method: this.method,
        id: this.id,
        className: this.className
      };
    })
  });

  // Add global navigation tracking to detect page reloads
  let isFilterUpdateInProgress = false;

  // Store original beforeunload handlers
  const originalBeforeunload = window.onbeforeunload;
  const originalBeforeunloadListeners = [];

  // Override window.onbeforeunload completely
  window.onbeforeunload = function (e) {
    console.log('[filter-debug] window.onbeforeunload called:', {
      timestamp: new Date().toISOString(),
      isFilterUpdateInProgress: isFilterUpdateInProgress,
      beforeunloadDisabled: window.testlabFiltersBeforeunloadDisabled,
      eventType: e ? e.type : 'unknown',
      defaultPrevented: e ? e.defaultPrevented : 'unknown',
      stackTrace: new Error().stack
    });

    // Always prevent unload during filter updates - silent prevention
    if (isFilterUpdateInProgress || window.testlabFiltersBeforeunloadDisabled) {
      console.log(
        '[filter-debug] Silently preventing page reload via window.onbeforeunload - returning null'
      );
      return null; // Return null to prevent alert
    }

    // Call original handler if it exists
    if (originalBeforeunload) {
      console.log('[filter-debug] Calling original beforeunload handler');
      return originalBeforeunload.call(this, e);
    }

    console.log('[filter-debug] No original handler, returning null');
    return null;
  };

  window.addEventListener('beforeunload', function (e) {
    console.log('[filter-debug] beforeunload event listener triggered:', {
      timestamp: new Date().toISOString(),
      reason: 'beforeunload',
      isFilterUpdateInProgress: isFilterUpdateInProgress,
      beforeunloadDisabled: window.testlabFiltersBeforeunloadDisabled,
      eventType: e.type,
      defaultPrevented: e.defaultPrevented,
      stackTrace: new Error().stack
    });

    // Always prevent unload during filter updates - silent prevention
    if (isFilterUpdateInProgress || window.testlabFiltersBeforeunloadDisabled) {
      console.log(
        '[filter-debug] Silently preventing page reload during filter update - preventing event'
      );
      // Cancel the event completely without showing alert
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      // Don't set returnValue to avoid showing confirmation dialog
      return;
    }
  });

  // Track any click events that might cause navigation
  document.addEventListener(
    'click',
    function (e) {
      const target = e.target;
      const href = target.href || target.closest('a')?.href;
      const isSubmitButton =
        target.type === 'submit' || target.closest('button[type="submit"]');

      if (href || isSubmitButton) {
        console.log('--> [filter-debug] Potentially navigational click detected:', {
          timestamp: new Date().toISOString(),
          target: target.tagName,
          targetId: target.id,
          targetClass: target.className,
          href: href,
          isSubmitButton: isSubmitButton,
          isDefaultPrevented: e.defaultPrevented,
          isPropagationStopped: e.isPropagationStopped
            ? e.isPropagationStopped()
            : false
        });
      }

      // Prevent navigation during filter updates - but allow our own buttons to work
      if (
        (isFilterUpdateInProgress ||
          window.testlabFiltersBeforeunloadDisabled) &&
        (href || isSubmitButton)
      ) {
        // Allow our own filter buttons to work
        const isOurButton =
          target.closest('[data-clear-filters]') ||
          target.closest('[data-apply-filters]') ||
          target.closest('.faceted-active-filters__clear') ||
          target.closest('.faceted-active-filters__remove-filter') ||
          target.closest('[data-mobile-filter-toggle]') ||
          target.closest('[data-mobile-filter-close]');

        if (!isOurButton) {
          console.log(
            '[filter-debug] Preventing navigation click during filter update:',
            {
              target: target.tagName,
              targetId: target.id,
              targetClass: target.className,
              href: href,
              isSubmitButton: isSubmitButton
            }
          );
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        } else {
          console.log(
            '[filter-debug] Allowing our button click during filter update:',
            {
              target: target.tagName,
              targetId: target.id,
              targetClass: target.className
            }
          );
        }
      }
    },
    true
  ); // Use capture phase to catch events early

  // Track any programmatic navigation attempts using a different approach
  const originalAssign = window.location.assign;
  const originalReplace = window.location.replace;

  window.location.assign = function (url) {
    console.log('[filter-debug] window.location.assign called:', {
      timestamp: new Date().toISOString(),
      url: url,
      stackTrace: new Error().stack
    });
    return originalAssign.call(this, url);
  };

  window.location.replace = function (url) {
    console.log('[filter-debug] window.location.replace called:', {
      timestamp: new Date().toISOString(),
      url: url,
      stackTrace: new Error().stack
    });
    return originalReplace.call(this, url);
  };

  // Also track direct href assignment - try a safer approach
  try {
    const originalHref = Object.getOwnPropertyDescriptor(
      Location.prototype,
      'href'
    );
    if (originalHref && originalHref.set) {
      Object.defineProperty(window.location, 'href', {
        get: originalHref.get,
        set: function (value) {
          console.log('[filter-debug] window.location.href being set:', {
            timestamp: new Date().toISOString(),
            newValue: value,
            currentValue: window.location.href,
            stackTrace: new Error().stack
          });
          originalHref.set.call(this, value);
        }
      });
    }
  } catch (e) {
    console.log('[filter-debug] Could not override location.href:', e.message);
  }

  // Debounce timer for UI updates
  let updateFilterUITimer;

  // Loading spinner cleanup timer
  let loadingCleanupTimer = null;
  const LOADING_TIMEOUT = 4000; // 4 seconds timeout

  // Function to cleanup stuck loading spinner
  function cleanupStuckLoadingSpinner() {
    console.log('[filter-debug] Checking for stuck loading spinner');
    
    const $loadingIcon = jQuery('.paginate');
    const $collectionGrid = jQuery('.collection-matrix');
    
    if ($loadingIcon.is(':visible') || $collectionGrid.hasClass('loading-in-progress')) {
      console.warn('[filter-debug] Stuck loading spinner detected - forcing cleanup');
      
      // Force hide loading spinner
      $loadingIcon.hide();
      $collectionGrid.removeClass('loading-in-progress');
      
      // Reset filter update flag
      isFilterUpdateInProgress = false;
      
      // Re-enable beforeunload listeners
      enableBeforeunload();
      
      console.log('[filter-debug] Forced cleanup of stuck loading spinner completed');
    } else {
      console.log('[filter-debug] No stuck loading spinner detected - cleanup not needed');
    }
  }

  // Function to start loading cleanup timer
  function startLoadingCleanupTimer() {
    // Clear any existing timer
    if (loadingCleanupTimer) {
      clearTimeout(loadingCleanupTimer);
      console.log('[filter-debug] Cleared existing cleanup timer');
    }
    
    // Set new timer
    loadingCleanupTimer = setTimeout(() => {
      console.log('[filter-debug] Cleanup timer triggered after', LOADING_TIMEOUT, 'ms');
      cleanupStuckLoadingSpinner();
      loadingCleanupTimer = null;
    }, LOADING_TIMEOUT);
    
    console.log('[filter-debug] Started loading cleanup timer (' + LOADING_TIMEOUT + 'ms timeout)');
  }

  // Function to stop loading cleanup timer
  function stopLoadingCleanupTimer() {
    if (loadingCleanupTimer) {
      clearTimeout(loadingCleanupTimer);
      loadingCleanupTimer = null;
      console.log('[filter-debug] Stopped loading cleanup timer');
    } else {
      console.log('[filter-debug] No cleanup timer to stop');
    }
  }

  // Function to update UI when a checkbox changes (no AJAX)
  function updateFilterUI(checkbox) {
    console.log('[filter-debug] updateFilterUI called for checkbox:', {
      id: checkbox.id,
      name: checkbox.name,
      value: checkbox.value,
      checked: checkbox.checked
    });

    // Set beforeunload flag to prevent other scripts from causing page reloads
    window.testlabFiltersBeforeunloadDisabled = true;
    console.log(
      '[filter-debug] Set beforeunload flag to prevent page reload:',
      {
        isFilterUpdateInProgress: isFilterUpdateInProgress,
        beforeunloadDisabled: window.testlabFiltersBeforeunloadDisabled
      }
    );

    // Clear any pending update
    if (updateFilterUITimer) {
      clearTimeout(updateFilterUITimer);
    }

    // Debounce the update to prevent rapid-fire calls
    updateFilterUITimer = setTimeout(() => {
      // Sync the state between desktop and mobile forms
      syncFormStates(checkbox);

      // Update the active filters display to reflect the current checkbox state
      updateActiveFiltersDisplay();

      // Update active filter counts next to category headings
      updateActiveFilterCounts();

      // On desktop, trigger AJAX update immediately
      // On mobile, AJAX will be triggered when sidebar closes
      const isDesktop = window.innerWidth > 1100;
      if (isDesktop && !isFilterUpdateInProgress) {
        console.log(
          '[filter-debug] Desktop detected - triggering immediate AJAX update'
        );
        const currentFilters = getCurrentFilterUrl();
        updateCollection(currentFilters);
      } else if (isFilterUpdateInProgress) {
        console.log(
          '[filter-debug] Skipping desktop AJAX - update already in progress'
        );
      } else {
        console.log(
          '[filter-debug] Mobile detected - AJAX will trigger on sidebar close'
        );
      }

      // Reset flags after UI update is complete
      setTimeout(() => {
        const isDesktop = window.innerWidth > 1100;
        if (isDesktop) {
          // On desktop, only reset the beforeunload flag - let updateCollection handle the isFilterUpdateInProgress flag
          window.testlabFiltersBeforeunloadDisabled = false;
          console.log(
            '[filter-debug] Reset beforeunload flag after UI update (desktop):',
            {
              isFilterUpdateInProgress: isFilterUpdateInProgress,
              beforeunloadDisabled: window.testlabFiltersBeforeunloadDisabled
            }
          );
        } else {
          // On mobile, keep flags set until sidebar closes and AJAX completes
          console.log(
            '[filter-debug] Keeping flags set on mobile until sidebar close'
          );
        }
      }, 100);
    }, 50); // 50ms debounce
  }

  // Function to sync checkbox states between desktop and mobile forms
  function syncFormStates(changedCheckbox) {
    const name = changedCheckbox.name;
    const value = changedCheckbox.value;
    const checked = changedCheckbox.checked;

    console.log('[filter-debug] Syncing form states for:', {
      name,
      value,
      checked
    });

    // Find the corresponding checkbox in the OTHER form and sync its state
    // If clicked checkbox is in desktop form, sync mobile form (and vice versa)
    const isDesktopCheckbox = $newDesktopForm.find(changedCheckbox).length > 0;

    if (isDesktopCheckbox) {
      // Desktop checkbox clicked - sync mobile form
      $newMobileForm
        .find(`input[name="${name}"][value="${value}"]`)
        .each(function () {
          console.log('[filter-debug] Syncing mobile checkbox from desktop:', {
            id: this.id,
            from: changedCheckbox.checked,
            to: checked
          });
          this.checked = checked;
        });
    } else {
      // Mobile checkbox clicked - sync desktop form
      $newDesktopForm
        .find(`input[name="${name}"][value="${value}"]`)
        .each(function () {
          console.log('[filter-debug] Syncing desktop checkbox from mobile:', {
            id: this.id,
            from: changedCheckbox.checked,
            to: checked
          });
          this.checked = checked;
        });
    }
  }

  // Debounce the active filters display update
  let updateActiveFiltersTimeout;

  // Function to update active filters display without AJAX
  function updateActiveFiltersDisplay() {
    // Clear any pending update
    if (updateActiveFiltersTimeout) {
      clearTimeout(updateActiveFiltersTimeout);
    }

    // Debounce the update to prevent rapid multiple calls
    updateActiveFiltersTimeout = setTimeout(() => {
      console.log(
        '[filter-debug] updateActiveFiltersDisplay executing - reading current UI state'
      );

      // Get all checked checkboxes from both forms - read current state
      const checkedFilters = {};
      $newDesktopForm
        .add($newMobileForm)
        .find('input[type="checkbox"]:checked')
        .each(function () {
          const name = this.name;
          const value = this.value;
          console.log('[filter-debug] Found checked filter for UI display:', {
            name,
            value,
            id: this.id
          });
          if (!checkedFilters[name]) {
            checkedFilters[name] = [];
          }
          // Only add if not already in the array (deduplicate)
          if (!checkedFilters[name].includes(value)) {
            checkedFilters[name].push(value);
          }
        });

      // Get price range values from both forms - read current state
      const desktopPriceMinFormatted =
        $newDesktopForm.find('input[name="filter.v.price.gte"]').val() || '';
      const mobilePriceMinFormatted =
        $newMobileForm.find('input[name="filter.v.price.gte"]').val() || '';
      const desktopPriceMaxFormatted =
        $newDesktopForm.find('input[name="filter.v.price.lte"]').val() || '';
      const mobilePriceMaxFormatted =
        $newMobileForm.find('input[name="filter.v.price.lte"]').val() || '';

      // Use whichever value is non-empty (they should be synced, but this is a safety check)
      const priceMinFormatted = desktopPriceMinFormatted || mobilePriceMinFormatted || '';
      const priceMaxFormatted = desktopPriceMaxFormatted || mobilePriceMaxFormatted || '';
      
      // Parse the formatted values to get clean numeric values
      const priceMin = parsePriceInput(priceMinFormatted);
      const priceMax = parsePriceInput(priceMaxFormatted);

      console.log('[filter-debug] Price range values for UI display:', {
        desktopPriceMinFormatted,
        mobilePriceMinFormatted,
        desktopPriceMaxFormatted,
        mobilePriceMaxFormatted,
        finalPriceMin: priceMin,
        finalPriceMax: priceMax
      });

      // Add price range to checked filters if set
      if (priceMin || priceMax) {
        // Format prices for display (remove decimals, add commas)
        const formatPriceForDisplay = (value) => {
          if (!value) return '';
          const numValue = parseInt(value) || 0;
          return numValue.toLocaleString();
        };

        const priceMinDisplay = formatPriceForDisplay(priceMin);
        const priceMaxDisplay = formatPriceForDisplay(priceMax);

        // Create price range display text
        let priceRangeText = '';
        if (priceMin && priceMax) {
          priceRangeText = `$${priceMinDisplay} - $${priceMaxDisplay}`;
        } else if (priceMin) {
          priceRangeText = `$${priceMinDisplay}+`;
        } else if (priceMax) {
          priceRangeText = `< $${priceMaxDisplay}`;
        }

        if (priceRangeText) {
          checkedFilters['price_range'] = [priceRangeText];
          console.log('[filter-debug] Added price range to checked filters:', priceRangeText);
        }
      }

      console.log(
        '[filter-debug] Current checked filters for UI display (including price range):',
        checkedFilters
      );

      // Remove existing active filters from both forms
      const existingActiveFilters = $newDesktopForm
        .add($newMobileForm)
        .find('.faceted-active-filters');

      console.log(
        '[filter-debug] Removing existing active filters:',
        existingActiveFilters.length
      );
      existingActiveFilters.parent().remove();

      // Update mobile active filters container
      const $mobileActiveFiltersContainer = jQuery('.mobile-active-filters');
      if ($mobileActiveFiltersContainer.length > 0) {
        console.log('[filter-debug] Updating mobile active filters container');

        // Clear existing content
        $mobileActiveFiltersContainer.empty();

        // Show/hide container based on whether filters exist
        if (Object.keys(checkedFilters).length > 0) {
          $mobileActiveFiltersContainer.show();

          // Create active filters HTML for mobile
          const mobileActiveFiltersHtml =
            createActiveFiltersHtml(checkedFilters);
          $mobileActiveFiltersContainer.html(mobileActiveFiltersHtml);

          // Convert any active filter links to buttons (for consistency)
          convertExistingActiveFilterLinks();

          // Add click handlers to mobile active filter buttons
          attachMobileActiveFilterHandlers();

          console.log(
            '[filter-debug] Mobile active filters container populated'
          );
        } else {
          $mobileActiveFiltersContainer.hide();
          console.log(
            '[filter-debug] Mobile active filters container hidden - no filters'
          );
        }
      }

      // Create new active filters if any are selected
      if (Object.keys(checkedFilters).length > 0) {
        console.log(
          '[filter-debug] Creating active filters HTML for:',
          checkedFilters
        );
        const activeFiltersHtml = createActiveFiltersHtml(checkedFilters);
        // console.log(
        //   '[filter-debug] Generated active filters HTML:',
        //   activeFiltersHtml
        // );

        // Add active filters to desktop form
        console.log('[filter-debug] Adding active filters to desktop form');
        $newDesktopForm.prepend(activeFiltersHtml);

        // Add active filters to mobile form (clone to avoid DOM conflicts)
        if ($newMobileForm.length > 0) {
          console.log('[filter-debug] Adding active filters to mobile form');
          const mobileActiveFiltersHtml = jQuery(activeFiltersHtml).clone();
          $newMobileForm.prepend(mobileActiveFiltersHtml);
        }

        // Convert any active filter links to buttons (for consistency)
        convertExistingActiveFilterLinks();

        // Add click handlers to the new active filter buttons
        attachActiveFilterHandlers();
      } else {
        console.log(
          '[filter-debug] No filters selected, no active filters to show'
        );
      }

      // Apply client-side review rating filtering after UI updates
      applyReviewRatingFilterToCollectionGrid();
    }, 10); // 10ms debounce
  }

  // Function to update active filter counts next to category headings
  function updateActiveFilterCounts() {
    console.log('[filter-debug] updateActiveFilterCounts called');

    // Find all sidebar blocks that contain filters
    $newDesktopForm
      .add($newMobileForm)
      .find('.sidebar__block')
      .each(function () {
        const $block = jQuery(this);
        const $heading = $block.find('.sidebar-block__heading');

        // Count checked checkboxes in this block
        const checkedCount = $block.find(
          'input[type="checkbox"]:checked'
        ).length;

        // Check if price filter has active values (count as 1 if either min or max is set)
        const priceInputsWithValues = $block
          .find('input[type="number"]')
          .filter(function () {
            return this.value && this.value.trim() !== '';
          }).length;
        const priceFilterActive = priceInputsWithValues > 0 ? 1 : 0;

        // Total active count is checkboxes + price filter (0 or 1)
        const totalActiveCount = checkedCount + priceFilterActive;

        console.log('[filter-debug] Block count update:', {
          blockId: $block.attr('id'),
          checkedCount: checkedCount,
          priceFilterActive: priceFilterActive,
          totalActiveCount: totalActiveCount
        });

        // Remove existing count spans
        $heading.find('.faceted-filter-group-summary__active-count').remove();

        // Add count if there are active filters
        if (totalActiveCount > 0) {
          const $countSpan = jQuery('<span>')
            .addClass('faceted-filter-group-summary__active-count')
            .text(`(${totalActiveCount})`);

          $heading.append($countSpan);

          console.log(
            '[filter-debug] Added active count:',
            totalActiveCount,
            'to block:',
            $block.attr('id')
          );
        }
      });
  }

  // Function to create HTML for active filters
  function createActiveFiltersHtml(checkedFilters) {
    let html = '<div><div class="faceted-active-filters">';

    // Add clear all button
    html +=
      '<button type="button" data-clear-url="' +
      escapeHtmlAttr(window.location.pathname) +
      '" class="button faceted-active-filters__clear">Clear all</button>';

    // Add individual filter remove buttons
    Object.entries(checkedFilters).forEach(([name, values]) => {
      values.forEach(value => {
        // Build URL without this specific filter
        const params = new URLSearchParams();

        // Handle price range filter specially
        if (name === 'price_range') {
          // For price range, we need to clear both min and max price parameters
          // Add all other filters except price range
          Object.entries(checkedFilters).forEach(([otherName, otherValues]) => {
            if (otherName !== 'price_range') {
              otherValues.forEach(otherValue => {
                params.append(otherName, otherValue);
              });
            }
          });
        } else {
          // For regular filters, add all other filters except the one being removed
          Object.entries(checkedFilters).forEach(([otherName, otherValues]) => {
            if (otherName !== name) {
              // Add all values for this filter name
              otherValues.forEach(otherValue => {
                params.append(otherName, otherValue);
              });
            } else {
              // For the same filter name, add all values except the one being removed
              otherValues.forEach(otherValue => {
                if (otherValue !== value) {
                  params.append(otherName, otherValue);
                }
              });
            }
          });
        }

        const removeUrl =
          window.location.pathname +
          (params.toString() ? '?' + params.toString() : '');

        // Handle review rating filters specially - format with stars
        let displayText = value;
        if (name === 'filter.c.review_rating') {
          const ratingNum = parseInt(value) || 0;
          const stars = '★'.repeat(ratingNum);
          const starText = ratingNum === 1 ? 'Star' : 'Stars';
          displayText = stars + ' ' + value + ' ' + starText;
        }

        html +=
          '<button type="button" data-remove-url="' +
          escapeHtmlAttr(removeUrl) +
          '" data-filter-name="' +
          escapeHtmlAttr(name) +
          '" class="faceted-active-filters__remove-filter button button--primary"><span class="icon clear-filter" data-icon="x"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="x"><polygon points="97.83 7.83 92.17 2.17 50 44.34 7.83 2.17 2.17 7.83 44.34 50 2.17 92.17 7.83 97.83 50 55.66 92.17 97.83 97.83 92.17 55.66 50 97.83 7.83"></polygon></g></svg></span><span class="faceted-active-filters__label">' +
          escapeHtmlText(displayText) +
          '</span></button>';
      });
    });

    html += '</div></div>';
    return html;
  }

  // Function to attach handlers to active filter buttons
  function attachActiveFilterHandlers() {
    // Remove filter buttons
    $newDesktopForm
      .add($newMobileForm)
      .find('.faceted-active-filters__remove-filter')
      .on('click', function (e) {
        e.preventDefault();
        const removeUrl = jQuery(this).attr('data-remove-url');
        console.log('--> [filter-debug] Remove filter clicked:', removeUrl);

        // Update URL parameters and checkbox states
        const url = new URL(removeUrl, window.location.origin);
        const params = new URLSearchParams(url.search);

        console.log(
          '[filter-debug] Parsing remove URL params:',
          params.toString()
        );

        // Update checkbox states in both forms based on new URL
        $newDesktopForm
          .add($newMobileForm)
          .find('input[type="checkbox"]')
          .each(function () {
            const name = this.name;
            const value = this.value;
            const shouldBeChecked = params.getAll(name).includes(value);
            const $checkbox = jQuery(this);
            const wasChecked = this.checked;
            console.log('[filter-debug] Updating checkbox:', {
              name,
              value,
              shouldBeChecked,
              wasChecked,
              id: this.id
            });
            $checkbox.prop('checked', shouldBeChecked);
            // Trigger change event if state actually changed to update visual state
            if (wasChecked !== shouldBeChecked) {
              $checkbox.trigger('change');
            }
          });

        // Update price range inputs based on new URL
        const priceMinParam = params.get('filter.v.price.gte');
        const priceMaxParam = params.get('filter.v.price.lte');
        
        // Format price values for display
        const formatPriceForDisplay = (value) => {
          if (!value) return '';
          const numValue = parseInt(value) || 0;
          return numValue.toLocaleString();
        };

        const priceMinFormatted = formatPriceForDisplay(priceMinParam);
        const priceMaxFormatted = formatPriceForDisplay(priceMaxParam);

        console.log('[filter-debug] Updating price inputs:', {
          priceMinParam,
          priceMaxParam,
          priceMinFormatted,
          priceMaxFormatted
        });

        // Update price inputs in both forms
        $newDesktopForm
          .add($newMobileForm)
          .find('input[name="filter.v.price.gte"]')
          .val(priceMinFormatted);
        
        $newDesktopForm
          .add($newMobileForm)
          .find('input[name="filter.v.price.lte"]')
          .val(priceMaxFormatted);

        // Update UI
        updateActiveFiltersDisplay();

        // Update active filter counts
        updateActiveFilterCounts();

        // Always trigger AJAX update immediately for remove filter (like mobile handlers)
        if (!isFilterUpdateInProgress) {
          console.log(
            '[filter-debug] Remove Filter - triggering immediate AJAX update'
          );
          updateCollection(removeUrl);
        } else {
          console.log(
            '[filter-debug] Skipping Remove Filter AJAX - update already in progress'
          );
        }
      });

    // Clear all button
    $newDesktopForm
      .add($newMobileForm)
      .find('.faceted-active-filters__clear')
      .on('click', function (e) {
        e.preventDefault();
        console.log('--> [filter-debug] Clear all clicked');

        // Uncheck all checkboxes in both forms
        $newDesktopForm
          .add($newMobileForm)
          .find('input[type="checkbox"]')
          .each(function () {
            const $checkbox = jQuery(this);
            const wasChecked = this.checked;
            $checkbox.prop('checked', false);
            // Trigger change event if checkbox was checked to update visual state
            if (wasChecked) {
              $checkbox.trigger('change');
            }
          });
        console.log('[filter-debug] All checkboxes unchecked');

        // Clear price range inputs in both forms
        $newDesktopForm
          .add($newMobileForm)
          .find('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]')
          .val('');
        console.log('[filter-debug] All price inputs cleared');

        // Update UI
        updateActiveFiltersDisplay();

        // Update active filter counts
        updateActiveFilterCounts();

        // Always trigger AJAX update immediately for clear all (like mobile handlers)
        if (!isFilterUpdateInProgress) {
          console.log(
            '[filter-debug] Clear All - triggering immediate AJAX update'
          );
          const clearUrl = window.location.pathname; // Clear all = no filters = base URL
          updateCollection(clearUrl);
        } else {
          console.log(
            '[filter-debug] Skipping Clear All AJAX - update already in progress'
          );
        }
      });
  }

  // Function to attach handlers to mobile active filter buttons
  function attachMobileActiveFilterHandlers() {
    const $mobileActiveFiltersContainer = jQuery('.mobile-active-filters');

    // Remove filter buttons
    $mobileActiveFiltersContainer
      .find('.faceted-active-filters__remove-filter')
      .on('click', function (e) {
        e.preventDefault();
        const removeUrl = jQuery(this).attr('data-remove-url');
        console.log('--> [filter-debug] Mobile remove filter clicked:', removeUrl);

        // Update URL parameters and checkbox states
        const url = new URL(removeUrl, window.location.origin);
        const params = new URLSearchParams(url.search);

        console.log(
          '[filter-debug] Mobile parsing remove URL params:',
          params.toString()
        );

        // Update checkbox states in both forms based on new URL
        $newDesktopForm
          .add($newMobileForm)
          .find('input[type="checkbox"]')
          .each(function () {
            const name = this.name;
            const value = this.value;
            const shouldBeChecked = params.getAll(name).includes(value);
            const $checkbox = jQuery(this);
            const wasChecked = this.checked;
            console.log('[filter-debug] Mobile updating checkbox:', {
              name,
              value,
              shouldBeChecked,
              wasChecked,
              id: this.id
            });
            $checkbox.prop('checked', shouldBeChecked);
            // Trigger change event if state actually changed to update visual state
            if (wasChecked !== shouldBeChecked) {
              $checkbox.trigger('change');
            }
          });

        // Update price range inputs based on new URL
        const priceMinParam = params.get('filter.v.price.gte');
        const priceMaxParam = params.get('filter.v.price.lte');
        
        // Format price values for display
        const formatPriceForDisplay = (value) => {
          if (!value) return '';
          const numValue = parseInt(value) || 0;
          return numValue.toLocaleString();
        };

        const priceMinFormatted = formatPriceForDisplay(priceMinParam);
        const priceMaxFormatted = formatPriceForDisplay(priceMaxParam);

        console.log('[filter-debug] Mobile updating price inputs:', {
          priceMinParam,
          priceMaxParam,
          priceMinFormatted,
          priceMaxFormatted
        });

        // Update price inputs in both forms
        $newDesktopForm
          .add($newMobileForm)
          .find('input[name="filter.v.price.gte"]')
          .val(priceMinFormatted);
        
        $newDesktopForm
          .add($newMobileForm)
          .find('input[name="filter.v.price.lte"]')
          .val(priceMaxFormatted);

        // Update UI
        updateActiveFiltersDisplay();

        // Update active filter counts
        updateActiveFilterCounts();

        // Always trigger AJAX update immediately for mobile active filters (like desktop)
        if (!isFilterUpdateInProgress) {
          console.log(
            '[filter-debug] Mobile remove filter - triggering immediate AJAX update'
          );
          updateCollection(removeUrl);
        } else {
          console.log(
            '[filter-debug] Skipping Mobile remove filter AJAX - update already in progress'
          );
        }
      });

    // Clear all button
    $mobileActiveFiltersContainer
      .find('.faceted-active-filters__clear')
      .on('click', function (e) {
        e.preventDefault();
        console.log('--> [filter-debug] Mobile clear all clicked');

        // Uncheck all checkboxes in both forms
        $newDesktopForm
          .add($newMobileForm)
          .find('input[type="checkbox"]')
          .each(function () {
            const $checkbox = jQuery(this);
            const wasChecked = this.checked;
            $checkbox.prop('checked', false);
            // Trigger change event if checkbox was checked to update visual state
            if (wasChecked) {
              $checkbox.trigger('change');
            }
          });
        console.log('[filter-debug] Mobile clear - all checkboxes unchecked');

        // Clear price range inputs
        $newDesktopForm
          .add($newMobileForm)
          .find('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]')
          .val('');
        console.log('[filter-debug] Mobile clear - all price inputs cleared');

        // Update UI
        updateActiveFiltersDisplay();

        // Update active filter counts
        updateActiveFilterCounts();

        // Always trigger AJAX update immediately for mobile active filters (like desktop)
        if (!isFilterUpdateInProgress) {
          console.log(
            '[filter-debug] Mobile Clear All - triggering immediate AJAX update'
          );
          const clearUrl = window.location.pathname; // Clear all = no filters = base URL
          updateCollection(clearUrl);
        } else {
          console.log(
            '[filter-debug] Skipping Mobile Clear All AJAX - update already in progress'
          );
        }
      });
  }

  // Function to process active filters and ensure proper price formatting
  function processActiveFiltersPriceFormatting() {
    console.log('[filter-debug] Processing active filters for price formatting');
    
    // Find all active filter buttons that contain price ranges
    $newDesktopForm
      .add($newMobileForm)
      .find('.faceted-active-filters__remove-filter')
      .each(function () {
        const $button = jQuery(this);
        const $label = $button.find('.faceted-active-filters__label').first();
        const $span = $label.length ? $label : $button.find('span').last();
        const text = $span.text().trim();
        
        // Check if this looks like a price range (contains $ and numbers)
        if (text.includes('$') && /\d/.test(text)) {
          console.log('[filter-debug] Found price range filter:', text);
          
          // Extract price values and reformat them
          const priceRangeMatch = text.match(/\$([0-9,]+)(?:\.00)?(?:\s*-\s*\$([0-9,]+)(?:\.00)?|\s*\+|\s*<\s*\$([0-9,]+)(?:\.00)?)/);
          
          if (priceRangeMatch) {
            let formattedText = '';
            
            if (priceRangeMatch[2]) {
              // Range format: $5,000 - $10,000
              const minPrice = parseInt(priceRangeMatch[1].replace(/,/g, '')) || 0;
              const maxPrice = parseInt(priceRangeMatch[2].replace(/,/g, '')) || 0;
              formattedText = `$${minPrice.toLocaleString()} - $${maxPrice.toLocaleString()}`;
            } else if (priceRangeMatch[3]) {
              // Less than format: < $10,000
              const maxPrice = parseInt(priceRangeMatch[3].replace(/,/g, '')) || 0;
              formattedText = `< $${maxPrice.toLocaleString()}`;
            } else if (text.includes('+')) {
              // Greater than format: $5,000+
              const minPrice = parseInt(priceRangeMatch[1].replace(/,/g, '')) || 0;
              formattedText = `$${minPrice.toLocaleString()}+`;
            }
            
            if (formattedText && formattedText !== text) {
              console.log('[filter-debug] Reformatting price range:', {
                original: text,
                formatted: formattedText
              });
              $span.text(formattedText);
            }
          }
        }
      });
  }

  // Function to update collection with filtered results (called only when mobile sidebar closes)
  function updateCollection(url) {
    console.log('[filter-debug] updateCollection called with URL:', url);
    isFilterUpdateInProgress = true;
    const $collectionGrid = jQuery('.collection-matrix');

    // Disable beforeunload listeners to prevent alerts
    disableBeforeunload();

    // Store open accordion panels (desktop + mobile forms can both be in DOM with duplicate block ids)
    const openSections = [];
    const seenOpenKeys = new Set();
    $newDesktopForm
      .add($newMobileForm)
      .find('.sidebar-block__content.is-active')
      .each(function () {
        const $block = jQuery(this).closest('.sidebar__block');
        const blockId = $block.attr('id');
        // Get label text without the count
        const blockLabel = $block
          .find('.sidebar-block__heading')
          .clone()
          .children()
          .remove()
          .end()
          .text()
          .trim();
        const key = blockId || blockLabel;
        if (!key || seenOpenKeys.has(key)) {
          return;
        }
        seenOpenKeys.add(key);
        openSections.push({ id: blockId, label: blockLabel });
      });

    console.log('[filter-debug] Open sections to preserve:', openSections);

    // Store current sort value before making the request
    const currentSortValue = jQuery('#sort-by').val();

    // Show loading state
    $loadingIcon.show();
    $collectionGrid.addClass('loading-in-progress');

    // Start cleanup timer to prevent stuck loading spinner
    startLoadingCleanupTimer();

    // Add template suffix as view parameter if it exists (safety check in case URL came from elsewhere)
    let finalUrl = url;
    const $section = jQuery('[data-template-suffix]').closest('section');
    const templateSuffix = $section.length ? $section.data('template-suffix') : null;
    if (templateSuffix) {
      try {
        const urlObj = new URL(url, window.location.origin);
        // Only add if not already present
        if (!urlObj.searchParams.has('view')) {
          urlObj.searchParams.set('view', templateSuffix);
          finalUrl = urlObj.pathname + (urlObj.search ? urlObj.search : '');
          console.log('[filter-debug] Added view parameter to URL:', {
            originalUrl: url,
            finalUrl: finalUrl,
            templateSuffix: templateSuffix
          });
        } else {
          console.log('[filter-debug] View parameter already present in URL, keeping existing value');
        }
      } catch (e) {
        console.warn('[filter-debug] Error parsing URL, using original:', e);
        finalUrl = url;
      }
    } else {
      console.log('[filter-debug] No template suffix found, using original URL');
    }

    console.log('[filter-debug] Starting AJAX fetch to:', finalUrl);
    console.log('[filter-debug] Original URL was:', url);

    // Starting filter update

    // Store original rimg functions but don't disable them completely
    const originalRimgWatch = window.PXUTheme?.rimg?.watch;
    const originalRimgUnwatch = window.PXUTheme?.rimg?.unwatch;

    // Fetch the filtered results
    fetch(finalUrl)
      .then(response => response.text())
      .then(html => {
        console.log('[filter-debug] Processing AJAX response for URL:', finalUrl);
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Find the new collection grid
        const $newCollectionGrid = jQuery(doc).find('.collection-matrix');

        // Update the collection grid
        if ($newCollectionGrid.length) {
          console.log('[filter-debug] New collection grid found in AJAX response:', {
            newGridLength: $newCollectionGrid.length,
            currentGridLength: $collectionGrid.length,
            currentGridExists: $collectionGrid.length > 0
          });

          // Handle case where collection grid doesn't exist initially (empty collection)
          if ($collectionGrid.length === 0) {
            console.log('[filter-debug] Collection grid does not exist - creating it from AJAX response');
            
            // Find the collection main container
            const $collectionMain = jQuery('.collection__main');
            if ($collectionMain.length > 0) {
              // Remove any "no products" messages
              $collectionMain.find('.collection__no-products, .no-products, .empty-collection, .container--no-products-in-collection').remove();
              
              // Add the new collection grid
              $collectionMain.append($newCollectionGrid);
              
              // Update our reference to point to the newly created grid
              const $newlyCreatedGrid = $collectionMain.find('.collection-matrix');
              console.log('[filter-debug] Created new collection grid:', {
                newlyCreatedLength: $newlyCreatedGrid.length,
                gridContent: $newlyCreatedGrid.html().substring(0, 100) + '...'
              });
              
              // Use the newly created grid for the rest of the processing
              $newlyCreatedGrid.each(function() {
                const $thisGrid = jQuery(this);
                
                // Apply two-items styling if needed
                const productCount = $thisGrid.find('.product__thumbnail').length;
                if (productCount === 2) {
                  console.log('[filter-debug] Applying two-items styling for 2-product collection');
                  $thisGrid.addClass('two-items');
                  $thisGrid.css({
                    'display': 'flex',
                    'justify-content': 'left',
                    'flex-wrap': 'wrap'
                  });
                }

                // Initialize lazy loading
                setTimeout(() => {
                  console.log('[filter-debug] Starting lazySizes initialization for newly created grid:', {
                    timestamp: new Date().toISOString(),
                    isTwoItems: $thisGrid.hasClass('two-items'),
                    productCount: $thisGrid.find('.product__thumbnail').length,
                    imageCount: $thisGrid.find('img[data-src]').length
                  });

                  if (typeof lazySizes !== 'undefined') {
                    console.log('[filter-debug] Using standard lazySizes initialization for newly created grid');
                    lazySizes.loader.checkElems();
                  } else {
                    console.log('[filter-debug] lazySizes not available - using fallback manual loading for newly created grid');
                    $thisGrid.find('img[data-src]').each(function () {
                      const $img = jQuery(this);
                      if ($img.data('src')) {
                        $img.attr('src', $img.data('src'));
                      }
                      if ($img.data('srcset')) {
                        $img.attr('srcset', $img.data('srcset'));
                      }
                      $img.addClass('lazyloaded').removeClass('lazyload');
                    });
                  }
                }, 200);

                // Initialize rimg for new images
                setTimeout(() => {
                  console.log('[filter-debug] Starting rimg initialization for newly created grid:', {
                    timestamp: new Date().toISOString(),
                    isTwoItems: $thisGrid.hasClass('two-items'),
                    imageCount: $thisGrid.find('img[data-rimg]').length
                  });
                  
                  const $newImages = $thisGrid.find('img[data-rimg]');
                  $newImages.each(function (index) {
                    if (
                      window.PXUTheme &&
                      window.PXUTheme.rimg &&
                      originalRimgWatch
                    ) {
                      console.log('[filter-debug] Initializing rimg for newly created image ' + index);
                      originalRimgWatch.call(window.PXUTheme.rimg, this);
                    }
                  });

                  // Trigger the theme:rimg:watch event
                  if (window.PXUTheme && window.PXUTheme.rimg) {
                    console.log('[filter-debug] Dispatching theme:rimg:watch event for newly created grid');
                    const event = new CustomEvent('theme:rimg:watch', {
                      detail: { container: $thisGrid[0] }
                    });
                    document.dispatchEvent(event);
                  }

                  console.log('[filter-debug] rimg initialization completed for newly created grid');
                }, 50);
              });
            } else {
              console.error('[filter-debug] Collection main container not found - cannot create collection grid');
            }
          } else {
            // Collection grid exists - proceed with normal replacement
            console.log('[filter-debug] Collection grid exists - proceeding with normal replacement');
            
            // Clean up existing images before replacement
            const $existingImages = $collectionGrid.find('img[data-rimg]');
            $existingImages.each(function () {
              if (
                window.PXUTheme &&
                window.PXUTheme.rimg &&
                originalRimgUnwatch
              ) {
                originalRimgUnwatch.call(window.PXUTheme.rimg, this);
              }
            });

            // Replace content
            $collectionGrid.html($newCollectionGrid.html());
            
            // Re-initialize rimg for new images with better timing
            setTimeout(() => {
            console.log('[filter-debug] Starting rimg initialization:', {
              timestamp: new Date().toISOString(),
              isTwoItems: $collectionGrid.hasClass('two-items'),
              imageCount: $collectionGrid.find('img[data-rimg]').length
            });
            
            const $newImages = $collectionGrid.find('img[data-rimg]');
            $newImages.each(function (index) {
              if (
                window.PXUTheme &&
                window.PXUTheme.rimg &&
                originalRimgWatch
              ) {
                console.log('[filter-debug] Initializing rimg for image ' + index);
                originalRimgWatch.call(window.PXUTheme.rimg, this);
              }
            });

            // Removed resize event to prevent autoSizer conflicts

            // Also trigger the theme:rimg:watch event for comprehensive coverage
            if (window.PXUTheme && window.PXUTheme.rimg) {
              console.log('[filter-debug] Dispatching theme:rimg:watch event');
              const event = new CustomEvent('theme:rimg:watch', {
                detail: { container: $collectionGrid[0] }
              });
              document.dispatchEvent(event);
            }

            // Removed redundant resize event to prevent timing conflicts
            console.log('[filter-debug] rimg initialization completed');
          }, 50); // Reduced delay for faster initialization
          } // End of else block for existing collection grid

          // Count the number of product thumbnails (only if collection grid exists)
          if ($collectionGrid.length > 0) {
            const productCount = $collectionGrid.find(
              '.product__thumbnail'
            ).length;

            // Apply two-items class and styling for collections with exactly 2 products
            if (productCount === 2) {
              console.log('[filter-debug] Applying two-items styling for 2-product collection');
              $collectionGrid.addClass('two-items');
              $collectionGrid.css({
                'display': 'flex',
                'justify-content': 'left',
                'flex-wrap': 'wrap'
              });
            } else {
              // Remove two-items class and reset styling for other product counts
              $collectionGrid.removeClass('two-items');
              $collectionGrid.css({
                'display': '',
                'justify-content': '',
                'flex-wrap': ''
              });
            }

            console.log('[filter-debug] Product count and styling applied:', {
              productCount,
              hasTwoItemsClass: $collectionGrid.hasClass('two-items')
            });
          } else {
            console.log('[filter-debug] Collection grid does not exist - skipping product count logic');
          }

       
          // Initialize lazy loading with proper timing - prevent autoSizer conflicts
          // Only if collection grid exists (for existing grids)
          if ($collectionGrid.length > 0) {
            setTimeout(() => {
              console.log('[filter-debug] Starting lazySizes initialization:', {
                timestamp: new Date().toISOString(),
                hasLazySizes: typeof lazySizes !== 'undefined',
                isTwoItems: $collectionGrid.hasClass('two-items'),
                productCount: $collectionGrid.find('.product__thumbnail').length,
                imageCount: $collectionGrid.find('img[data-src]').length
              });

              if (typeof lazySizes !== 'undefined') {
                // Always use standard lazySizes initialization now
                console.log('[filter-debug] Using standard lazySizes initialization for all layouts');
                lazySizes.loader.checkElems();
              } else {
                console.log('[filter-debug] lazySizes not available - using fallback manual loading');
                // Fallback: manually load images if lazySizes is not available
                $collectionGrid.find('img[data-src]').each(function () {
                  const $img = jQuery(this);
                  if ($img.data('src')) {
                    $img.attr('src', $img.data('src'));
                  }
                  if ($img.data('srcset')) {
                    $img.attr('srcset', $img.data('srcset'));
                  }
                  $img.addClass('lazyloaded').removeClass('lazyload');
                });
              }
            }, 200); // Increased delay to ensure rimg has fully processed two-items layout
          } else {
            console.log('[filter-debug] Collection grid does not exist - skipping lazy loading initialization');
          }
        } else {
          // No collection grid in AJAX response - check for "no products" message
          console.log('[filter-debug] No collection grid in AJAX response - checking for no products message');
          
          const $newNoProductsMessage = jQuery(doc).find('.container--no-products-in-collection, .collection__no-products, .no-products, .empty-collection');
          
          if ($newNoProductsMessage.length > 0) {
            console.log('[filter-debug] No products message found in AJAX response:', {
              noProductsLength: $newNoProductsMessage.length,
              currentGridLength: $collectionGrid.length,
              currentGridExists: $collectionGrid.length > 0
            });
            
            // Find the collection main container
            const $collectionMain = jQuery('.collection__main');
            if ($collectionMain.length > 0) {
              // Remove existing collection grid if it exists
              if ($collectionGrid.length > 0) {
                console.log('[filter-debug] Removing existing collection grid');
                $collectionGrid.remove();
              }
              
              // Remove any existing "no products" messages
              $collectionMain.find('.collection__no-products, .no-products, .empty-collection, .container--no-products-in-collection').remove();
              
              // Add the new "no products" message
              $collectionMain.append($newNoProductsMessage);
              
              console.log('[filter-debug] Added no products message to collection main');
            } else {
              console.error('[filter-debug] Collection main container not found - cannot add no products message');
            }
          } else {
            console.log('[filter-debug] No collection grid and no no-products message found in AJAX response');
          }
        }

        // Handle active filters
        const $newActiveFilters = jQuery(doc).find('.faceted-active-filters');
        const $existingActiveFilters = $newDesktopForm
          .add($newMobileForm)
          .find('.faceted-active-filters');

        console.log('[filter-debug] Processing active filters:', {
          timestamp: new Date().toISOString(),
          newActiveFiltersCount: $newActiveFilters.length,
          existingActiveFiltersCount: $existingActiveFilters.length,
          url: url
        });

        // Remove all existing active filters from both forms
        $existingActiveFilters.each(function () {
          jQuery(this).parent().remove();
        });

        // Add new active filters if they exist
        if ($newActiveFilters.length) {
          // Get the first active filters container and its parent
          const $firstNewActiveFilters = $newActiveFilters.first();
          const $newActiveFiltersContainer = $firstNewActiveFilters.parent();

          // Add to both desktop and mobile forms
          $newDesktopForm.prepend($newActiveFiltersContainer.clone());
          if ($newMobileForm.length > 0) {
            $newMobileForm.prepend($newActiveFiltersContainer.clone());
          }

          // Process the active filters to ensure proper price formatting
          processActiveFiltersPriceFormatting();

          // Convert any active filter links to buttons (from AJAX response)
          convertExistingActiveFilterLinks();

          // Add click handlers to the remove filter buttons
          $newDesktopForm
            .add($newMobileForm)
            .find('.faceted-active-filters__remove-filter')
            .on('click', function (e) {
              console.log('--> [filter-debug] Remove filter button clicked:', {
                timestamp: new Date().toISOString(),
                dataRemoveUrl: jQuery(this).attr('data-remove-url'),
                textContent: this.textContent.trim()
              });
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              const removeUrl = jQuery(this).attr('data-remove-url');
              if (removeUrl) {
                console.log(
                  '[filter-debug] Updating UI for remove URL:',
                  removeUrl
                );

                // Update URL parameters and checkbox states (UI only, no AJAX)
                const url = new URL(removeUrl, window.location.origin);
                const params = new URLSearchParams(url.search);

                // Update checkbox states in both forms based on new URL
                $newDesktopForm
                  .add($newMobileForm)
                  .find('input[type="checkbox"]')
                  .each(function () {
                    const name = this.name;
                    const value = this.value;
                    const shouldBeChecked = params.getAll(name).includes(value);
                    const $checkbox = jQuery(this);
                    const wasChecked = this.checked;
                    $checkbox.prop('checked', shouldBeChecked);
                    // Trigger change event if state actually changed to update visual state
                    if (wasChecked !== shouldBeChecked) {
                      $checkbox.trigger('change');
                    }
                  });

                // Update price range inputs based on new URL
                const priceMinParam = params.get('filter.v.price.gte');
                const priceMaxParam = params.get('filter.v.price.lte');
                
                // Format price values for display
                const formatPriceForDisplay = (value) => {
                  if (!value) return '';
                  const numValue = parseInt(value) || 0;
                  return numValue.toLocaleString();
                };

                const priceMinFormatted = formatPriceForDisplay(priceMinParam);
                const priceMaxFormatted = formatPriceForDisplay(priceMaxParam);

                console.log('[filter-debug] AJAX response updating price inputs:', {
                  priceMinParam,
                  priceMaxParam,
                  priceMinFormatted,
                  priceMaxFormatted
                });

                // Update price inputs in both forms
                $newDesktopForm
                  .add($newMobileForm)
                  .find('input[name="filter.v.price.gte"]')
                  .val(priceMinFormatted);
                
                $newDesktopForm
                  .add($newMobileForm)
                  .find('input[name="filter.v.price.lte"]')
                  .val(priceMaxFormatted);

                // Update UI
                updateActiveFiltersDisplay();

                // Update active filter counts
                updateActiveFilterCounts();

                // Always trigger AJAX update immediately for remove filter (like other handlers)
                if (!isFilterUpdateInProgress) {
                  console.log(
                    '[filter-debug] AJAX response Remove Filter - triggering immediate AJAX update'
                  );
                  updateCollection(removeUrl);
                } else {
                  console.log(
                    '[filter-debug] Skipping AJAX response Remove Filter AJAX - update already in progress'
                  );
                }
              }
              return false;
            });

          // Add click handler to the clear all button
          const $clearButton = $newDesktopForm
            .add($newMobileForm)
            .find('.faceted-active-filters__clear');
          console.log('[filter-debug] Clear all button found:', {
            count: $clearButton.length,
            dataClearUrl: $clearButton.attr('data-clear-url'),
            textContent: $clearButton.text().trim()
          });

          $clearButton.on('click', function (e) {
            console.log('--> [filter-debug] Clear all button clicked (UI ONLY):', {
              timestamp: new Date().toISOString(),
              dataClearUrl: jQuery(this).attr('data-clear-url'),
              textContent: this.textContent.trim()
            });
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            // Uncheck all checkboxes in both forms (UI only, no AJAX)
            $newDesktopForm
              .add($newMobileForm)
              .find('input[type="checkbox"]')
              .each(function () {
                const $checkbox = jQuery(this);
                const wasChecked = this.checked;
                $checkbox.prop('checked', false);
                // Trigger change event if checkbox was checked to update visual state
                if (wasChecked) {
                  $checkbox.trigger('change');
                }
              });
            // Clear price range inputs
            $newDesktopForm
              .add($newMobileForm)
              .find('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]')
              .val('');
            console.log('[filter-debug] AJAX clear - all price inputs cleared');

            console.log('[filter-debug] All filters cleared, updating UI');
            // Update UI
            updateActiveFiltersDisplay();

            // Update active filter counts
            updateActiveFilterCounts();

            // Always trigger AJAX update immediately for clear all (like mobile handlers)
            if (!isFilterUpdateInProgress) {
              console.log(
                '[filter-debug] Clear All (AJAX handler) - triggering immediate AJAX update'
              );
              const clearUrl = window.location.pathname; // Clear all = no filters = base URL
              updateCollection(clearUrl);
            } else {
              console.log(
                '[filter-debug] Skipping Clear All AJAX (AJAX handler) - update already in progress'
              );
            }
            return false;
          });
        } else {
          // No active filters in response - clear mobile active filters container
          const $mobileActiveFiltersContainer = jQuery(
            '.mobile-active-filters'
          );
          if ($mobileActiveFiltersContainer.length > 0) {
            console.log(
              '[filter-debug] AJAX response has no active filters - clearing mobile container'
            );
            $mobileActiveFiltersContainer.hide().empty();
          }
        }

        // Update mobile active filters container with current state after AJAX
        const $mobileActiveFiltersContainer = jQuery('.mobile-active-filters');
        if ($mobileActiveFiltersContainer.length > 0) {
          console.log(
            '[filter-debug] Updating mobile active filters container after AJAX'
          );

          // Get current checked filters from UI state
          const checkedFilters = {};
          $newDesktopForm
            .add($newMobileForm)
            .find('input[type="checkbox"]:checked')
            .each(function () {
              const name = this.name;
              const value = this.value;
              if (!checkedFilters[name]) {
                checkedFilters[name] = [];
              }
              if (!checkedFilters[name].includes(value)) {
                checkedFilters[name].push(value);
              }
            });

          // Update mobile container
          if (Object.keys(checkedFilters).length > 0) {
            $mobileActiveFiltersContainer.show();
            const mobileActiveFiltersHtml =
              createActiveFiltersHtml(checkedFilters);
            $mobileActiveFiltersContainer.html(mobileActiveFiltersHtml);
            
            // Convert any active filter links to buttons (for consistency)
            convertExistingActiveFilterLinks();
            
            attachMobileActiveFilterHandlers();
            console.log(
              '[filter-debug] Mobile active filters container updated after AJAX'
            );
          } else {
            $mobileActiveFiltersContainer.hide();
            console.log(
              '[filter-debug] Mobile active filters container hidden after AJAX'
            );
          }
        }

        // Update filter counts and checkbox states from new HTML BEFORE updating active filters display
        // This ensures checkbox states are correct when updateActiveFiltersDisplay() reads them
        const $parsedForms = jQuery(doc).find('form.faceted-filter-form');
        function findParsedSidebarBlock(blockId) {
          if (!blockId) {
            return jQuery();
          }
          let $found = jQuery();
          $parsedForms.each(function () {
            const $hit = jQuery(this).find('#' + blockId);
            if ($hit.length) {
              $found = $hit.first();
              return false;
            }
          });
          return $found;
        }

        $newDesktopForm.add($newMobileForm).each(function () {
          const $liveForm = jQuery(this);
          if (!$liveForm.length) {
            return;
          }
          $liveForm.find('.sidebar__block').each(function () {
            const $block = jQuery(this);
            const blockId = $block.attr('id');
            const $heading = $block.find('.sidebar-block__heading');

            const $newBlock = findParsedSidebarBlock(blockId);
            if ($newBlock.length) {
              $heading
                .find('.faceted-filter-group-summary__active-count')
                .remove();

              const $newCount = $newBlock.find(
                '.sidebar-block__heading .faceted-filter-group-summary__active-count'
              );

              if ($newCount.length) {
                const $countClone = $newCount.first().clone();
                $heading.append($countClone);
              }

              $block.find('input[type="checkbox"]').each(function () {
                const $checkbox = jQuery(this);
                const checkboxId = $checkbox.attr('id');
                const $newCheckbox = $newBlock.find('#' + checkboxId);

                if ($newCheckbox.length) {
                  $checkbox.prop('checked', $newCheckbox.prop('checked'));
                }
              });
            }
          });
        });

        // Reinitialize review rating checkboxes from URL parameters (frontend-only filter)
        // Pass the URL that will be pushed to history so it reads the correct review_rating values
        initializeReviewRatingFilters(url);

        // Update active filters display to include rating filters (client-side only)
        // This ensures rating filters are preserved even though they're not in the AJAX response
        // Must be called AFTER checkbox states are updated so it reads the correct state
        console.log('[filter-debug] Updating active filters display after AJAX to include rating filters');
        updateActiveFiltersDisplay();

        // Update sort dropdown to match the stored sort value
        if (currentSortValue && jQuery('#sort-by').length) {
          jQuery('#sort-by').val(currentSortValue);
        }

        // Update price range inputs based on current URL parameters
        const currentUrl = new URL(url, window.location.origin);
        const currentParams = new URLSearchParams(currentUrl.search);
        const priceMinParam = currentParams.get('filter.v.price.gte');
        const priceMaxParam = currentParams.get('filter.v.price.lte');
        
        // Format price values for display
        const formatPriceForDisplay = (value) => {
          if (!value) return '';
          const numValue = parseInt(value) || 0;
          return numValue.toLocaleString();
        };

        const priceMinFormatted = formatPriceForDisplay(priceMinParam);
        const priceMaxFormatted = formatPriceForDisplay(priceMaxParam);

        console.log('[filter-debug] AJAX response updating price inputs:', {
          priceMinParam,
          priceMaxParam,
          priceMinFormatted,
          priceMaxFormatted
        });

        // Update price inputs in both forms
        $newDesktopForm
          .add($newMobileForm)
          .find('input[name="filter.v.price.gte"]')
          .val(priceMinFormatted);
        
        $newDesktopForm
          .add($newMobileForm)
          .find('input[name="filter.v.price.lte"]')
          .val(priceMaxFormatted);

        // Restore open sections — must scope by form: duplicate ids (e.g. filter-section-brand) exist
        // on desktop vs mobile, so document-wide jQuery('#id') can open the wrong (hidden) panel.
        function restoreOpenSectionInForm($formRoot, section) {
          if (!$formRoot || !$formRoot.length) {
            return;
          }
          let $block;
          if (section.id) {
            $block = $formRoot.find('#' + section.id);
          }
          if (!$block || !$block.length) {
            $block = $formRoot.find('.sidebar__block').filter(function () {
              const blockLabel = jQuery(this)
                .find('.sidebar-block__heading')
                .clone()
                .children()
                .remove()
                .end()
                .text()
                .trim();
              return blockLabel === section.label;
            });
          }

          if ($block.length) {
            const $content = $block.find('.sidebar-block__content');
            const $caret = $block.find('.filter-caret');

            if ($content.length) {
              $content
                .addClass('is-active')
                .css('display', 'block')
                .css('maxHeight', $content[0].scrollHeight + 'px');

              if ($caret.length) {
                $caret.css('transform', 'rotate(180deg)');
              }
              $block
                .find('[data-sidebar-block__toggle]')
                .attr('data-sidebar-block__toggle', 'open');
            }
          }
        }

        openSections.forEach(section => {
          restoreOpenSectionInForm($newDesktopForm, section);
          restoreOpenSectionInForm($newMobileForm, section);
        });

        // Also keep sections open if they have active filters (checked checkboxes or price values)
        $newDesktopForm.add($newMobileForm).find('.sidebar__block').each(function () {
          const $block = jQuery(this);
          const $content = $block.find('.sidebar-block__content');
          const $caret = $block.find('.filter-caret');
          const hasActiveFilters =
            $block.find('input[type="checkbox"]:checked').length > 0;

          // Check if price filter has active values
          const hasPriceValues =
            $block.find('input[type="number"]').filter(function () {
              return this.value && this.value.trim() !== '';
            }).length > 0;

          if ((hasActiveFilters || hasPriceValues) && $content.length) {
            $content
              .addClass('is-active')
              .css('display', 'block')
              .css('maxHeight', $content[0].scrollHeight + 'px');

            if ($caret.length) {
              $caret.css('transform', 'rotate(180deg)');
            }
          }
        });

        // Apply client-side review rating filter to newly loaded products
        applyReviewRatingFilterToCollectionGrid();

        // Update URL without reloading the page
        console.log('[filter-debug] Updating URL with history.pushState:', url);
        window.history.pushState({ path: url }, '', url);
        console.log('[filter-debug] URL updated successfully');

        // Reinitialize currency converter if it exists
        if (
          typeof Currency !== 'undefined' &&
          typeof Currency.convertAll === 'function'
        ) {
          Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
        }

        // Trigger update event
        window.dispatchEvent(new CustomEvent('collection:updated'));

        // Lazy loading is already handled above - no need for duplicate calls

        // Reinitialize accordion state to ensure proper display
        setTimeout(() => {
          initializeAccordion();
        }, 50);

        // Additional trigger for lazySizes after a short delay - removed to prevent conflicts
        // The initial lazySizes call above should be sufficient
      })
      .catch(error => {
        console.error(
          '[testlabFilters] Error fetching filtered results:',
          error
        );
        
        // Don't stop cleanup timer on error - let it handle the cleanup
        // The cleanup timer will handle hiding the loading spinner
      })
      .finally(() => {
        console.log('[filter-debug] AJAX request completed - cleaning up loading state');
        
        // Always stop cleanup timer since we're in finally block
        // This means the AJAX request completed (success or error)
        stopLoadingCleanupTimer();

        // Hide loading state
        $loadingIcon.hide();
        $collectionGrid.removeClass('loading-in-progress');

        // Reset filter update flag
        isFilterUpdateInProgress = false;

        // Re-enable beforeunload listeners
        enableBeforeunload();

        console.log('[filter-debug] Filter update completed, reset flag');

        // Rimg system was not disabled, so no restoration needed
      });
  }

  // Add event listeners to checkboxes in both forms
  const $allCheckboxes = $newDesktopForm
    .add($newMobileForm)
    .find('input[type="checkbox"]');

  console.log(
    '[filter-debug] Found checkboxes:',
    $allCheckboxes.length,
    'checkboxes across both forms'
  );

  $allCheckboxes.each(function (index) {
    const $checkbox = jQuery(this);
    // console.log(
    //   '[filter-debug] Setting up handlers for checkbox:',
    //   this.id,
    //   'name:',
    //   this.name,
    //   'value:',
    //   this.value
    // );

    // Add change handler - only update UI, no AJAX
    $checkbox.on('change', function (e) {
      console.log('[filter-debug] Checkbox change:', this.id, this.checked);
      updateFilterUI(this);
    });
  });

  // Add event listeners to labels
  const $labels = $form.find('.faceted-filter-group-display__list-item-label');

  $labels.each(function () {
    const $label = jQuery(this);

    $label.on('click', function (e) {
      const forId = $label.attr('for');
      console.log('--> [filter-debug] Label click:', forId);

      // Prevent default to avoid any form submission or native label behavior
      e.preventDefault();
      e.stopPropagation();

      // Try to find the associated checkbox by "for" attribute first
      let $checkbox = null;
      if (forId) {
        $checkbox = jQuery(`#${forId}`);
      }

      // Fallback: locate the nearest checkbox within the same list item
      if (!$checkbox || !$checkbox.length) {
        $checkbox = $label
          .closest('.faceted-filter-group-display__list-item')
          .find('input[type="checkbox"]')
          .first();
      }

      if ($checkbox && $checkbox.length) {
        $checkbox.prop('checked', !$checkbox.prop('checked'));
        // Trigger change event to update UI and AJAX
        $checkbox.trigger('change');
      } else {
        console.warn(
          '[filter-debug] No checkbox found for label click - check markup for label/checkbox pairing',
          {
            forId: forId,
            labelText: $label.text().trim()
          }
        );
      }
    });
  });

  // Handle sort dropdown changes
  const $sortDropdown = jQuery('#sort-by');
  if ($sortDropdown.length) {
    // Add change handler for sort dropdown
    $sortDropdown.on('change', function () {
      // Get the new sort value
      const newSortValue = jQuery(this).val() || '';
      console.log('[filter-debug] Sort change - new sort value:', newSortValue);

      // Use getCurrentFilterUrl() with the new sort value to ensure all filters are captured
      // This ensures consistency and that we don't miss any filter types
      const url = getCurrentFilterUrl(newSortValue);

      console.log(
        '[filter-debug] Sort change - final URL built with all filters:',
        url
      );

      // Update collection - always trigger immediately for sort changes
      // (Sort dropdown is only visible on desktop anyway)
      console.log(
        '[filter-debug] Sort dropdown changed - triggering immediate AJAX update'
      );
      updateCollection(url);
    });
  }

  // Add event listeners to price inputs to sync between forms
  const $priceInputs = $newDesktopForm
    .add($newMobileForm)
    .find('input[type="number"][name^="filter.v.price"]');

  console.log('[filter-debug] Found price inputs:', $priceInputs.length);

  // Handle input events with immediate formatting to prevent interference
  const formatTimeouts = new Map(); // Use Map to store timeouts per input
  
  // Add a flag to prevent utilities.js from interfering with our price inputs
  // Also change input type from 'number' to 'text' to allow comma formatting
  $priceInputs.each(function() {
    this.setAttribute('data-price-filter', 'true');
    this.setAttribute('data-original-type', this.type);
    this.type = 'text';
    this.setAttribute('inputmode', 'numeric');
    this.setAttribute('pattern', '[0-9,]*');
  });

  
  $priceInputs.on('input', function () {
    const $input = jQuery(this);
    const name = this.name;
    const value = this.value;
    const inputId = this.id;

    console.log('[filter-debug] Price input changed:', {
      name,
      value,
      id: inputId,
      timestamp: new Date().toISOString()
    });

    // Format immediately to prevent other code from interfering
    if (value && /\d/.test(value)) {
      const formattedValue = formatPriceInput(value);
      
      // Only update if the formatted value is different
      if (formattedValue !== value) {
        // Store cursor position
        const cursorPosition = this.selectionStart;
        const valueLength = value.length;
        
        // Update the value
        this.value = formattedValue;
        
        // For price inputs, always position cursor at the end after formatting
        // This allows users to continue typing at the end (e.g., 5,000 → 15,000)
        const newLength = formattedValue.length;
        
        // Restore cursor position at the end
        setTimeout(() => {
          this.setSelectionRange(newLength, newLength);
        }, 0);
        
        console.log('[filter-debug] Applied immediate formatting:', {
          inputId,
          originalValue: value,
          formattedValue,
          finalValue: this.value
        });
      }
    }

    // Check value before syncing
    console.log('[filter-debug] Before sync - current input value:', {
      inputId,
      value: this.value,
      isEmpty: this.value === ''
    });

    // Sync the current value between desktop and mobile forms
    const isDesktopInput = $newDesktopForm.find(this).length > 0;

    if (isDesktopInput) {
      // Desktop input changed - sync mobile form
      $newMobileForm.find(`input[name="${name}"]`).val(this.value);
      console.log('[filter-debug] Synced price from desktop to mobile:', {
        name,
        value: this.value,
        syncedToMobile: $newMobileForm.find(`input[name="${name}"]`).val()
      });
    } else {
      // Mobile input changed - sync desktop form
      $newDesktopForm.find(`input[name="${name}"]`).val(this.value);
      console.log('[filter-debug] Synced price from mobile to desktop:', {
        name,
        value: this.value,
        syncedToDesktop: $newDesktopForm.find(`input[name="${name}"]`).val()
      });
    }

    // Check value after syncing
    console.log('[filter-debug] After sync - current input value:', {
      inputId,
      value: this.value,
      isEmpty: this.value === ''
    });

    // Clear any existing timeout for this specific input
    if (formatTimeouts.has(inputId)) {
      clearTimeout(formatTimeouts.get(inputId));
    }
    
    // Set a timeout to update active filter counts after user stops typing
    const timeoutId = setTimeout(() => {
      console.log('[filter-debug] Timeout triggered - checking value:', {
        inputId,
        value: this.value,
        isEmpty: this.value === ''
      });
      
      // Update active filter counts after formatting is complete
      updateActiveFilterCounts();
      
      // Remove timeout from map
      formatTimeouts.delete(inputId);
    }, 100); // Short delay to update counts
    
    // Store timeout ID in map
    formatTimeouts.set(inputId, timeoutId);
  });


  // Format existing price values on page load
  $priceInputs.each(function() {
    const currentValue = this.value;
    console.log('[filter-debug] Page load - processing input:', {
      name: this.name,
      currentValue: currentValue,
      type: typeof currentValue
    });
    
    if (currentValue && currentValue.trim() !== '') {
      const formattedValue = formatPriceInput(currentValue);
      console.log('[filter-debug] Page load - setting formatted value:', {
        original: currentValue,
        formatted: formattedValue
      });
      this.value = formattedValue;
    }
  });

  // Handle price filter submit buttons specifically
  const $priceSubmitButtons = $newDesktopForm
    .add($newMobileForm)
    .find('.faceted-filter-group-display__submit button[type="submit"]');

  console.log(
    '[filter-debug] Found price filter submit buttons:',
    $priceSubmitButtons.length
  );

  $priceSubmitButtons.on('click', function (e) {
    console.log('--> [filter-debug] Price filter submit button clicked');
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // Get the price inputs from the form that contains this button
    const $parentForm = jQuery(this).closest('form.faceted-filter-form');
    const $priceMinInput = $parentForm.find('input[name="filter.v.price.gte"]');
    const $priceMaxInput = $parentForm.find('input[name="filter.v.price.lte"]');
    
    // Get raw values and format them
    const priceMinRaw = $priceMinInput.val() || '';
    const priceMaxRaw = $priceMaxInput.val() || '';
    
    const priceMinFormatted = formatPriceInput(priceMinRaw);
    const priceMaxFormatted = formatPriceInput(priceMaxRaw);
    
    // Update the inputs with formatted values
    $priceMinInput.val(priceMinFormatted);
    $priceMaxInput.val(priceMaxFormatted);

    // Parse the formatted values to get clean numeric values
    const priceMin = parsePriceInput(priceMinFormatted);
    const priceMax = parsePriceInput(priceMaxFormatted);

    console.log('[filter-debug] Price values from submit button form:', {
      priceMinRaw,
      priceMaxRaw,
      priceMinFormatted,
      priceMaxFormatted,
      priceMin,
      priceMax,
      formIsDesktop: $newDesktopForm.is($parentForm),
      isFilterUpdateInProgress: isFilterUpdateInProgress
    });

    // Sync price values to the other form before triggering update
    const isDesktopForm = $newDesktopForm.is($parentForm);
    if (isDesktopForm) {
      $newMobileForm.find('input[name="filter.v.price.gte"]').val(priceMinFormatted);
      $newMobileForm.find('input[name="filter.v.price.lte"]').val(priceMaxFormatted);
    } else {
      $newDesktopForm.find('input[name="filter.v.price.gte"]').val(priceMinFormatted);
      $newDesktopForm.find('input[name="filter.v.price.lte"]').val(priceMaxFormatted);
    }

    // Update active filter counts to reflect price filter
    updateActiveFilterCounts();

    // On desktop, trigger AJAX update immediately
    // On mobile, just close the sidebar (which will trigger AJAX)
    const isDesktop = window.innerWidth > 1100;
    console.log('[filter-debug] Price filter submit - checking conditions:', {
      isDesktop,
      isFilterUpdateInProgress,
      windowWidth: window.innerWidth
    });
    
    if (isDesktop && !isFilterUpdateInProgress) {
      console.log(
        '[filter-debug] Desktop price filter - triggering immediate AJAX update'
      );
      const currentFilters = getCurrentFilterUrl();
      console.log('[filter-debug] Current filters URL:', currentFilters);
      updateCollection(currentFilters);
    } else if (isFilterUpdateInProgress) {
      console.log(
        '[filter-debug] Skipping price filter AJAX - update already in progress',
        {
          isFilterUpdateInProgress: isFilterUpdateInProgress,
          isDesktop: isDesktop,
          windowWidth: window.innerWidth
        }
      );
    } else {
      console.log(
        '[filter-debug] Mobile price filter - closing sidebar to trigger AJAX',
        {
          isDesktop: isDesktop,
          isFilterUpdateInProgress: isFilterUpdateInProgress,
          windowWidth: window.innerWidth
        }
      );
      closeMobileSidebar();
    }

    return false;
  });

  // Handle form submission (for price filters) - prevent default, no AJAX
  $form.on('submit', function (e) {
    console.log(
      '[filter-debug] Form submit prevented - AJAX will happen on sidebar close'
    );
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    return false;
  });

  // Initialize accordion state based on viewport
  function initializeAccordion() {
    // Handle both desktop sidebar and mobile sidebar
    const $filterBlocks = $sidebarSection
      .add($mobileFilterSidebar)
      .find('.sidebar__block');

    $filterBlocks.each(function () {
      const $block = jQuery(this);
      const $content = $block.find('.sidebar-block__content');
      const $caret = $block.find('.filter-caret');
      const hasActiveFilters =
        $block.find('input[type="checkbox"]:checked').length > 0;

      // Check if price filter has active values
      const hasPriceValues =
        $block.find('input[type="number"]').filter(function () {
          return this.value && this.value.trim() !== '';
        }).length > 0;

      // Check if this block should be open on load (from data attributes)
      const shouldBeOpenOnLoad =
        $block.find('[data-sidebar-block__toggle="open"]').length > 0;

      if ($content.length && $caret.length) {
        // Expand when this block has selections, server says open, or the shopper already expanded
        // it in this session (.is-active). Collapse otherwise so a full page refresh re-applies
        // closed state (inline max-height from clicking is not persisted across reloads).
        const shouldStayOpen =
          hasActiveFilters ||
          hasPriceValues ||
          shouldBeOpenOnLoad ||
          $content.hasClass('is-active');

        if (shouldStayOpen) {
          $content.addClass('is-active').css({
            display: 'block',
            maxHeight: $content[0].scrollHeight + 'px',
            overflow: 'hidden'
          });
          $caret.css('transform', 'rotate(180deg)');

          $block
            .find('[data-sidebar-block__toggle]')
            .attr('data-sidebar-block__toggle', 'open');
        } else {
          $content.removeClass('is-active').css({
            maxHeight: '0px',
            overflow: 'hidden'
          });
          $caret.css('transform', 'rotate(0deg)');

          $block
            .find('[data-sidebar-block__toggle]')
            .attr('data-sidebar-block__toggle', 'closed');
        }
      }
    });
  }

  // Desktop accordion functionality
  const $desktopBlocks = $sidebarSection.find('.sidebar__block');

  $desktopBlocks.each(function () {
    const $block = jQuery(this);

    $block.on('click', function (e) {
      // Ignore clicks on filter items
      if (
        jQuery(e.target).closest('.faceted-filter-group-display__list-item')
          .length
      ) {
        return;
      }

      // Only handle clicks on the heading or toggle icon
      const $clickedElement = jQuery(e.target);
      const isHeading = $clickedElement.closest(
        '.sidebar-block__heading'
      ).length;
      const isToggleIcon = $clickedElement.closest(
        '.sidebar-block__toggle-icon'
      ).length;

      if (!isHeading && !isToggleIcon) {
        return;
      }

      const $content = $block.find('.sidebar-block__content');
      const $caret = $block.find('.filter-caret');

      if (!$content.length || !$content.hasClass('sidebar-block__content')) {
        return;
      }

      // Toggle the active class
      const isActive = $content.hasClass('is-active');

      // Close all other filter sections
      const $allContents = $form.find('.sidebar-block__content');
      const $allCarets = $form.find('.filter-caret');

      $allContents.each(function (index) {
        if (this !== $content[0]) {
          jQuery(this).removeClass('is-active').css('maxHeight', '0px');
          if ($allCarets.eq(index).length) {
            $allCarets.eq(index).css('transform', 'rotate(0deg)');
          }
        }
      });

      // Toggle current section
      if (isActive) {
        $content.removeClass('is-active').css('maxHeight', '0px');
        if ($caret.length) {
          $caret.css('transform', 'rotate(0deg)');
        }
      } else {
        const scrollHeight = $content[0].scrollHeight;
        $content
          .addClass('is-active')
          .css('display', 'block')
          .css('maxHeight', scrollHeight + 'px');
        if ($caret.length) {
          $caret.css('transform', 'rotate(180deg)');
        }
      }
    });
  });

  // Mobile accordion functionality
  const $mobileBlocks = $mobileFilterSidebar.find('.sidebar__block');

  $mobileBlocks.each(function () {
    const $block = jQuery(this);

    $block.on('click', function (e) {
      // Ignore clicks on filter items
      if (
        jQuery(e.target).closest('.faceted-filter-group-display__list-item')
          .length
      ) {
        return;
      }

      // Only handle clicks on the heading or toggle icon
      const $clickedElement = jQuery(e.target);
      const isHeading = $clickedElement.closest(
        '.sidebar-block__heading'
      ).length;
      const isToggleIcon = $clickedElement.closest(
        '.sidebar-block__toggle-icon'
      ).length;

      if (!isHeading && !isToggleIcon) {
        return;
      }

      const $content = $block.find('.sidebar-block__content');
      const $caret = $block.find('.filter-caret');

      if (!$content.length || !$content.hasClass('sidebar-block__content')) {
        return;
      }

      // Toggle the active class
      const isActive = $content.hasClass('is-active');

      // Close all other filter sections in mobile sidebar
      const $allMobileContents = $mobileFilterSidebar.find(
        '.sidebar-block__content'
      );
      const $allMobileCarets = $mobileFilterSidebar.find('.filter-caret');

      $allMobileContents.each(function (index) {
        if (this !== $content[0]) {
          jQuery(this).removeClass('is-active').css('maxHeight', '0px');
          if ($allMobileCarets.eq(index).length) {
            $allMobileCarets.eq(index).css('transform', 'rotate(0deg)');
          }
        }
      });

      // Toggle current section
      if (isActive) {
        $content.removeClass('is-active').css('maxHeight', '0px');
        if ($caret.length) {
          $caret.css('transform', 'rotate(0deg)');
        }
      } else {
        const scrollHeight = $content[0].scrollHeight;
        $content
          .addClass('is-active')
          .css('display', 'block')
          .css('maxHeight', scrollHeight + 'px');
        if ($caret.length) {
          $caret.css('transform', 'rotate(180deg)');
        }
      }
    });
  });

  // Mobile filter toggle functionality
  console.log('[filter-debug] Mobile filter elements found:', {
    toggle: $mobileFilterToggle.length,
    overlay: $mobileFilterOverlay.length,
    sidebar: $mobileFilterSidebar.length,
    toggleElement: $mobileFilterToggle[0],
    overlayElement: $mobileFilterOverlay[0],
    sidebarElement: $mobileFilterSidebar[0]
  });

  // Double-check after a short delay in case elements are rendered later
  setTimeout(() => {
    const $delayedMobileFilterToggle = jQuery('[data-mobile-filter-toggle]');
    const $delayedMobileFilterOverlay = jQuery('[data-mobile-filter-overlay]');
    const $delayedMobileFilterSidebar = jQuery('[data-mobile-filter-sidebar]');

    console.log(
      '[filter-debug] Delayed check - Mobile filter elements found:',
      {
        toggle: $delayedMobileFilterToggle.length,
        overlay: $delayedMobileFilterOverlay.length,
        sidebar: $delayedMobileFilterSidebar.length
      }
    );

    if (
      $delayedMobileFilterToggle.length > 0 &&
      $mobileFilterToggle.length === 0
    ) {
      console.log(
        '[filter-debug] Mobile filter toggle found on delayed check - setting up handler'
      );
      jQuery(document).on('click', '[data-mobile-filter-toggle]', function (e) {
        console.log(
          '--> [filter-debug] Mobile filter toggle clicked (delayed handler):',
          {
            timestamp: new Date().toISOString(),
            target: e.target.tagName,
            currentTarget: e.currentTarget.tagName,
            buttonText: e.currentTarget.textContent.trim()
          }
        );

        const isActive = $delayedMobileFilterOverlay.hasClass('is-active');
        console.log('[filter-debug] Current overlay state (delayed):', {
          isActive
        });

        if (isActive) {
          console.log('[filter-debug] Closing mobile sidebar (delayed)');
          $delayedMobileFilterOverlay.removeClass('is-active');
          $delayedMobileFilterSidebar.removeClass('is-active');
          jQuery('body').css('overflow', '');
        } else {
          console.log('[filter-debug] Opening mobile sidebar (delayed)');
          $delayedMobileFilterOverlay.addClass('is-active');
          $delayedMobileFilterSidebar.addClass('is-active');
          jQuery('body').css('overflow', 'hidden');
        }
      });
    }
  }, 100);

  // Remove any existing handlers first
  $mobileFilterToggle.off('click');

  if (
    $mobileFilterToggle.length &&
    $mobileFilterOverlay.length &&
    $mobileFilterSidebar.length
  ) {
    console.log('[filter-debug] Setting up mobile filter toggle handler');

    // Use event delegation to ensure the handler works
    jQuery(document).on('click', '[data-mobile-filter-toggle]', function (e) {
      console.log('--> [filter-debug] Mobile filter toggle clicked:', {
        timestamp: new Date().toISOString(),
        target: e.target.tagName,
        currentTarget: e.currentTarget.tagName,
        buttonText: e.currentTarget.textContent.trim(),
        element: e.currentTarget
      });

      const isActive = $mobileFilterOverlay.hasClass('is-active');
      console.log('[filter-debug] Current overlay state:', { isActive });

      if (isActive) {
        console.log('[filter-debug] Closing mobile sidebar');
        closeMobileSidebar();
      } else {
        console.log('[filter-debug] Opening mobile sidebar');
        openMobileSidebar();
      }
    });

    console.log(
      '[filter-debug] Mobile filter toggle handler attached successfully'
    );
  } else {
    console.log(
      '[filter-debug] Mobile filter elements not found - cannot setup toggle'
    );
    console.log(
      '[filter-debug] Available elements with data-mobile-filter-toggle:',
      jQuery('[data-mobile-filter-toggle]').length
    );
  }

  // Mobile filter close functionality
  if ($mobileFilterClose.length) {
    console.log('[filter-debug] Setting up mobile filter close handler');
    $mobileFilterClose.on('click', function (e) {
      console.log('--> [filter-debug] Mobile filter close button clicked');
      closeMobileSidebar();
    });
  } else {
    console.log('[filter-debug] Mobile filter close button not found');
  }

  // Mobile filter clear and apply buttons functionality
  const $mobileClearButton = jQuery('[data-clear-filters]');
  const $mobileApplyButton = jQuery('[data-apply-filters]');

  console.log('[filter-debug] Mobile filter buttons found:', {
    clearButton: $mobileClearButton.length,
    applyButton: $mobileApplyButton.length
  });

  // Clear filters button handler
  if ($mobileClearButton.length) {
    console.log(
      '[filter-debug] Setting up mobile clear filters button handler'
    );
    $mobileClearButton.on('click', function (e) {
      console.log('--> [filter-debug] Mobile clear filters button clicked');
      e.preventDefault();
      e.stopPropagation();

      // Uncheck all checkboxes in both forms
      $newDesktopForm
        .add($newMobileForm)
        .find('input[type="checkbox"]')
        .prop('checked', false);

      // Clear price range inputs
      $newDesktopForm.add($newMobileForm).find('input[type="number"]').val('');

      console.log('[filter-debug] All filters cleared via mobile button');

      // Update UI
      updateActiveFiltersDisplay();
      updateActiveFilterCounts();
    });
  } else {
    console.log('[filter-debug] Mobile clear filters button not found');
  }

  // Apply filters button handler
  if ($mobileApplyButton.length) {
    console.log(
      '[filter-debug] Setting up mobile apply filters button handler'
    );
    $mobileApplyButton.on('click', function (e) {
      console.log('--> [filter-debug] Mobile apply filters button clicked');
      e.preventDefault();
      e.stopPropagation();

      // Add visual feedback
      const $button = jQuery(this);
      $button.addClass('is-loading').prop('disabled', true);

      // Close the mobile sidebar and trigger AJAX update
      closeMobileSidebar();

      // Remove loading state after a short delay
      setTimeout(() => {
        $button.removeClass('is-loading').prop('disabled', false);
      }, 1000);
    });
  } else {
    console.log('[filter-debug] Mobile apply filters button not found');
  }

  // Mobile filter overlay click to close
  if ($mobileFilterOverlay.length) {
    console.log(
      '[filter-debug] Setting up mobile filter overlay click handler'
    );
    $mobileFilterOverlay.on('click', function (e) {
      console.log('[filter-debug] Mobile filter overlay clicked:', {
        target: e.target.tagName,
        currentTarget: e.currentTarget.tagName,
        isDirectClick: e.target === this
      });
      if (e.target === this) {
        console.log('[filter-debug] Direct overlay click - closing sidebar');
        closeMobileSidebar();
      }
    });
  } else {
    console.log('[filter-debug] Mobile filter overlay not found');
  }

  // Functions for mobile sidebar
  function openMobileSidebar() {
    console.log('[filter-debug] openMobileSidebar called');

    // Detect iPhone/iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isSafari =
      /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    const isIOSSafari = isIOS && isSafari;

    console.log('[filter-debug] Device detection:', {
      isIOS,
      isSafari,
      isIOSSafari,
      userAgent: navigator.userAgent
    });

    $mobileFilterOverlay.addClass('is-active');
    $mobileFilterSidebar.addClass('is-active');

    // Handle iPhone Safari specific viewport issues
    if (isIOSSafari) {
      // Set viewport height to account for address bar
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);

      // Add iOS-specific class for styling
      $mobileFilterSidebar.addClass('ios-safari');

      // Handle safe area insets for iPhone X and newer
      const hasSafeArea = window.screen.height > window.innerHeight + 100;
      if (hasSafeArea) {
        $mobileFilterSidebar.addClass('has-safe-area');
        console.log('[filter-debug] iPhone with safe area detected');
      }

      // Store scroll position BEFORE modifying body
      window.iosScrollPosition = window.scrollY;

      // Prevent body scroll more aggressively on iOS
      // Use absolute positioning instead of fixed for better iOS compatibility
      jQuery('body').addClass('ios-modal-open');

      // Set the modal to use absolute positioning for better iOS Safari support
      $mobileFilterSidebar.addClass('ios-absolute-position');

      // Store iOS handler for cleanup (but don't add global listeners here)
      // The main resize handler will handle iOS viewport changes
      window.iosViewportHandler = null;

      console.log('[filter-debug] iOS Safari modal positioning applied');
    } else {
      jQuery('body').css('overflow', 'hidden');
    }

    console.log('[filter-debug] Mobile sidebar opened successfully');
  }

  function closeMobileSidebar() {
    console.log('[filter-debug] closeMobileSidebar called');

    // Detect iPhone/iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isSafari =
      /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    const isIOSSafari = isIOS && isSafari;

    // Close the sidebar
    $mobileFilterOverlay.removeClass('is-active');
    $mobileFilterSidebar
      .removeClass('is-active')
      .removeClass('ios-safari')
      .removeClass('has-safe-area')
      .removeClass('ios-absolute-position');

    // Restore body scroll handling based on device
    if (isIOSSafari) {
      // Restore iOS-specific body styles
      jQuery('body').removeClass('ios-modal-open');

      // Clean up viewport resize listeners (if any were added)
      if (window.iosViewportHandler) {
        window.removeEventListener('resize', window.iosViewportHandler);
        window.removeEventListener(
          'orientationchange',
          window.iosViewportHandler
        );
        window.iosViewportHandler = null;
        console.log('[filter-debug] iOS viewport listeners cleaned up');
      }

      // Restore scroll position
      if (window.iosScrollPosition !== undefined) {
        window.scrollTo(0, window.iosScrollPosition);
        window.iosScrollPosition = undefined;
      }

      console.log('[filter-debug] iOS Safari modal closed and scroll restored');
    } else {
      jQuery('body').css('overflow', '');
    }

    // Trigger AJAX update with current filter state
    const currentFilters = getCurrentFilterUrl();
    console.log(
      '[filter-debug] Triggering AJAX update on sidebar close:',
      currentFilters
    );
    updateCollection(currentFilters);

    console.log(
      '[filter-debug] Mobile sidebar closed and AJAX update triggered'
    );
  }

  // Function to build current filter URL
  function getCurrentFilterUrl(sortOverride) {
    console.log(
      '[filter-debug] getCurrentFilterUrl called - reading from current UI state',
      sortOverride ? `(sort override: ${sortOverride})` : ''
    );

    // Get all checked checkboxes from both forms - read current state
    // Use :checkbox selector which is more reliable than input[type="checkbox"]
    const checkedFilters = {};
    $newDesktopForm
      .add($newMobileForm)
      .find(':checkbox:checked')
      .each(function () {
        const name = this.name;
        const value = this.value;
        console.log('[filter-debug] Found checked filter:', {
          name,
          value,
          id: this.id
        });
        if (!checkedFilters[name]) {
          checkedFilters[name] = [];
        }
        // Only add if not already in the array (deduplicate)
        if (!checkedFilters[name].includes(value)) {
          checkedFilters[name].push(value);
        }
      });

    console.log(
      '[filter-debug] getCurrentFilterUrl - checked filters from UI:',
      checkedFilters
    );

    // Get price range values from both forms - read current state
    // We need to check both forms and use the non-empty value
    const desktopPriceMinFormatted =
      $newDesktopForm.find('input[name="filter.v.price.gte"]').val() || '';
    const mobilePriceMinFormatted =
      $newMobileForm.find('input[name="filter.v.price.gte"]').val() || '';
    const desktopPriceMaxFormatted =
      $newDesktopForm.find('input[name="filter.v.price.lte"]').val() || '';
    const mobilePriceMaxFormatted =
      $newMobileForm.find('input[name="filter.v.price.lte"]').val() || '';

    // Use whichever value is non-empty (they should be synced, but this is a safety check)
    const priceMinFormatted = desktopPriceMinFormatted || mobilePriceMinFormatted || '';
    const priceMaxFormatted = desktopPriceMaxFormatted || mobilePriceMaxFormatted || '';
    
    // Parse the formatted values to get clean numeric values
    const priceMin = parsePriceInput(priceMinFormatted);
    const priceMax = parsePriceInput(priceMaxFormatted);

    console.log('[filter-debug] getCurrentFilterUrl - price range from UI:', {
      desktopPriceMinFormatted,
      mobilePriceMinFormatted,
      desktopPriceMaxFormatted,
      mobilePriceMaxFormatted,
      finalPriceMin: priceMin,
      finalPriceMax: priceMax
    });

    // Get current sort parameter (use override if provided)
    const currentSort = sortOverride !== undefined ? sortOverride : (jQuery('#sort-by').val() || '');
    console.log(
      '[filter-debug] getCurrentFilterUrl - sort from UI:',
      currentSort
    );

    // Build URL parameters
    const params = new URLSearchParams();

    // Add checked filters
    Object.entries(checkedFilters).forEach(([name, values]) => {
      values.forEach(value => {
        params.append(name, value);
        console.log('[filter-debug] Adding filter param:', { name, value });
      });
    });

    // Add price range if set
    if (priceMin) {
      params.append('filter.v.price.gte', priceMin);
      console.log('[filter-debug] Adding price min param:', priceMin);
    }
    if (priceMax) {
      params.append('filter.v.price.lte', priceMax);
      console.log('[filter-debug] Adding price max param:', priceMax);
    }

    // Add sort parameter if set
    if (currentSort) {
      params.append('sort_by', currentSort);
      console.log('[filter-debug] Adding sort param:', currentSort);
    }

    // Add template suffix as view parameter if it exists
    const $section = jQuery('[data-template-suffix]').closest('section');
    const templateSuffix = $section.length ? $section.data('template-suffix') : null;
    if (templateSuffix) {
      params.append('view', templateSuffix);
      console.log('[filter-debug] Adding view param (template suffix):', templateSuffix);
    }

    // Build the URL
    const finalUrl =
      Object.keys(checkedFilters).length === 0 &&
      !priceMin &&
      !priceMax &&
      !currentSort &&
      !templateSuffix
        ? window.location.pathname
        : `${window.location.pathname}?${params.toString()}`;

    console.log(
      '[filter-debug] getCurrentFilterUrl - final URL built from UI state:',
      finalUrl
    );
    console.log(
      '[filter-debug] getCurrentFilterUrl - params object:',
      params.toString()
    );
    return finalUrl;
  }

  // Convert existing active filter links to buttons to prevent page reloads
  function convertExistingActiveFilterLinks() {
    console.log(
      '[filter-debug] Converting existing active filter links to buttons'
    );

    // Find all existing active filter links
    const $existingActiveFilters = $newDesktopForm
      .add($newMobileForm)
      .find('.faceted-active-filters');

    if ($existingActiveFilters.length === 0) {
      console.log('[filter-debug] No existing active filters found to convert');
      return;
    }

    // Convert remove filter links to buttons
    $existingActiveFilters
      .find('a.faceted-active-filters__remove-filter')
      .each(function () {
        const $link = jQuery(this);
        const href = $link.attr('href');
        const text = $link.html();

        console.log('[filter-debug] Converting remove filter link:', {
          href,
          text
        });

        // Create button with same styling and content
        const $button = jQuery('<button>')
          .attr('type', 'button')
          .attr('data-remove-url', href)
          .attr('class', $link.attr('class'))
          .attr('data-filter-name', $link.attr('data-filter-name'))
          .html(text);

        // Replace the link with the button
        $link.replaceWith($button);
      });

    // Convert clear all links to buttons
    $existingActiveFilters
      .find('a.faceted-active-filters__clear')
      .each(function () {
        const $link = jQuery(this);
        const href = $link.attr('href');
        const text = $link.text();

        console.log('[filter-debug] Converting clear all link:', {
          href,
          text
        });

        // Create button with same styling and content
        const $button = jQuery('<button>')
          .attr('type', 'button')
          .attr('data-clear-url', href)
          .attr('class', $link.attr('class'))
          .attr('data-filter-name', $link.attr('data-filter-name'))
          .text(text);

        // Replace the link with the button
        $link.replaceWith($button);
      });

    // Process price formatting for any converted buttons
    processActiveFiltersPriceFormatting();

    // Attach event handlers to the newly created buttons
    attachActiveFilterHandlers();

    console.log(
      '[filter-debug] Active filter links converted to buttons successfully'
    );
  }

  // Initialize on load
  initializeAccordion();

  // Convert existing active filter links to buttons
  convertExistingActiveFilterLinks();

  // Update active filters display and counts on initial load
  // This ensures review rating filters from URL are displayed
  updateActiveFiltersDisplay();
  updateActiveFilterCounts();

  // Attach handlers to mobile active filters that were populated via Liquid
  const $existingMobileActiveFilters = jQuery('.mobile-active-filters');
  if (
    $existingMobileActiveFilters.length > 0 &&
    $existingMobileActiveFilters.find('.faceted-active-filters').length > 0
  ) {
    console.log(
      '[filter-debug] Attaching handlers to existing mobile active filters from Liquid'
    );
    attachMobileActiveFilterHandlers();
  }
  // Add global functions for debugging
  window.testlabFilters = {
    openMobileSidebar: openMobileSidebar,
    closeMobileSidebar: closeMobileSidebar,
    testMobileToggle: function () {
      console.log('[filter-debug] Testing mobile toggle manually');
      const $toggle = jQuery('[data-mobile-filter-toggle]');
      const $overlay = jQuery('[data-mobile-filter-overlay]');
      const $sidebar = jQuery('[data-mobile-filter-sidebar]');

      console.log('[filter-debug] Manual test - elements found:', {
        toggle: $toggle.length,
        overlay: $overlay.length,
        sidebar: $sidebar.length
      });

      if ($overlay.length && $sidebar.length) {
        $overlay.addClass('is-active');
        $sidebar.addClass('is-active');
        jQuery('body').css('overflow', 'hidden');
        console.log('[filter-debug] Mobile sidebar opened manually');
      } else {
        console.log(
          '[filter-debug] Mobile sidebar elements not found for manual test'
        );
      }
    },
    reinitializeMobileButtons: function () {
      console.log('[filter-debug] Reinitializing mobile filter buttons');
      const $clearButton = jQuery('[data-clear-filters]');
      const $applyButton = jQuery('[data-apply-filters]');

      console.log('[filter-debug] Mobile buttons found during reinit:', {
        clearButton: $clearButton.length,
        applyButton: $applyButton.length
      });

      // The global event delegation should handle these, but this provides a fallback
      return {
        clearButton: $clearButton.length,
        applyButton: $applyButton.length
      };
    },
    cleanupStuckLoadingSpinner: cleanupStuckLoadingSpinner,
    startLoadingCleanupTimer: startLoadingCleanupTimer,
    stopLoadingCleanupTimer: stopLoadingCleanupTimer,
    forceCleanupLoading: function() {
      console.log('[filter-debug] Manual cleanup of loading spinner requested');
      cleanupStuckLoadingSpinner();
    },
    resetFilterUpdateFlag: function() {
      console.log('[filter-debug] Manually resetting isFilterUpdateInProgress flag');
      isFilterUpdateInProgress = false;
      enableBeforeunload();
    },
    getFilterUpdateStatus: function() {
      return {
        isFilterUpdateInProgress: isFilterUpdateInProgress,
        loadingCleanupTimer: loadingCleanupTimer !== null,
        windowWidth: window.innerWidth,
        isDesktop: window.innerWidth > 1100
      };
    },
    triggerAjaxUpdate: function() {
      console.log('[filter-debug] Manual AJAX update triggered via window.testlabFilters');
      if (isFilterUpdateInProgress) {
        console.warn('[filter-debug] AJAX update already in progress - skipping manual trigger');
        return false;
      }
      const currentFilters = getCurrentFilterUrl();
      console.log('[filter-debug] Manual trigger - current filters URL:', currentFilters);
      updateCollection(currentFilters);
      return true;
    },
    triggerAjaxUpdateWithUrl: function(url) {
      console.log('[filter-debug] Manual AJAX update triggered with specific URL:', url);
      if (isFilterUpdateInProgress) {
        console.warn('[filter-debug] AJAX update already in progress - skipping manual trigger');
        return false;
      }
      updateCollection(url);
      return true;
    }
  };

  // Check initial product count and apply 2-item styling if needed
  const initialProductCount = $collectionGrid.find(
    '.product__thumbnail'
  ).length;

  // Apply two-items class and styling for initial load with exactly 2 products
  if (initialProductCount === 2) {
    console.log('[filter-debug] Applying initial two-items styling for 2-product collection');
    $collectionGrid.addClass('two-items');
    $collectionGrid.css({
      'display': 'flex',
      'justify-content': 'left',
      'flex-wrap': 'wrap'
    });
  }

  console.log('[filter-debug] Initial product count and styling applied:', {
    initialProductCount,
    hasTwoItemsClass: $collectionGrid.hasClass('two-items')
  });

  // Track previous viewport state to detect actual changes
  let previousViewportIsDesktop = window.innerWidth > 1100;

  // Handle viewport changes and trigger AJAX if switching to desktop
  function handleViewportChange() {
    const isDesktop = window.innerWidth > 1100;
    const hasActiveFilters =
      $newDesktopForm.add($newMobileForm).find('input[type="checkbox"]:checked')
        .length > 0;

    // Only trigger AJAX if we actually switched from mobile to desktop
    const switchedToDesktop = isDesktop && !previousViewportIsDesktop;

    // Don't trigger AJAX if one is already in progress
    if (switchedToDesktop && hasActiveFilters && !isFilterUpdateInProgress) {
      console.log(
        '[filter-debug] Switched to desktop with active filters - triggering AJAX update'
      );
      const currentFilters = getCurrentFilterUrl();
      updateCollection(currentFilters);
    } else if (isFilterUpdateInProgress) {
      console.log(
        '[filter-debug] Skipping viewport change AJAX - update already in progress'
      );
    } else if (switchedToDesktop && !hasActiveFilters) {
      console.log(
        '[filter-debug] Switched to desktop but no active filters - no AJAX needed'
      );
    } else if (isDesktop === previousViewportIsDesktop) {
      console.log(
        '[filter-debug] Viewport change detected but no desktop switch - no AJAX needed'
      );
    }

    // Update the previous state
    previousViewportIsDesktop = isDesktop;
  };
}